(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[998],{

/***/ 6983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.J = void 0;
const recoil_1 = __webpack_require__(4480);
/**
 * Recoil module to persist state to storage
 *
 * @param config Optional configuration object
 * @param config.key Used as key in local storage, defaults to `recoil-persist`
 * @param config.storage Local storage to use, defaults to `localStorage`
 */
const recoilPersist = (config = {}) => {
    if (typeof window === 'undefined') {
        return {
            persistAtom: () => { },
        };
    }
    const { key = 'recoil-persist', storage = localStorage } = config;
    const persistAtom = ({ onSet, node, trigger, setSelf }) => {
        if (trigger === 'get') {
            const state = getState();
            if (typeof state.then === 'function') {
                state.then((s) => {
                    if (s.hasOwnProperty(node.key)) {
                        setSelf(s[node.key]);
                    }
                });
            }
            if (state.hasOwnProperty(node.key)) {
                setSelf(state[node.key]);
            }
        }
        onSet(async (newValue) => {
            const state = getState();
            if (typeof state.then === 'function') {
                state.then((s) => updateState(newValue, s, node.key));
            }
            else {
                updateState(newValue, state, node.key);
            }
        });
    };
    const updateState = (newValue, state, key) => {
        if (newValue !== null &&
            newValue !== undefined &&
            newValue instanceof recoil_1.DefaultValue &&
            state.hasOwnProperty(key)) {
            delete state[key];
        }
        else {
            state[key] = newValue;
        }
        setState(state);
    };
    const getState = () => {
        const toParse = storage.getItem(key);
        if (toParse === null || toParse === undefined) {
            return {};
        }
        if (typeof toParse === 'string') {
            return parseState(toParse);
        }
        if (typeof toParse.then === 'function') {
            return toParse.then(parseState);
        }
        return {};
    };
    const parseState = (state) => {
        if (state === undefined) {
            return {};
        }
        try {
            return JSON.parse(state);
        }
        catch (e) {
            console.error(e);
            return {};
        }
    };
    const setState = (state) => {
        try {
            if (typeof storage.mergeItem === 'function') {
                storage.mergeItem(key, JSON.stringify(state));
            }
            else {
                storage.setItem(key, JSON.stringify(state));
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    return { persistAtom };
};
exports.J = recoilPersist;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 54073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    now = __webpack_require__(61100),
    toNumber = __webpack_require__(7642);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 61100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 12436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(54073),
    isObject = __webpack_require__(29259);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 88226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/qna/write",
      function () {
        return __webpack_require__(74390);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98240);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);




var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7642), __webpack_require__.e(3540)]).then(__webpack_require__.bind(__webpack_require__, 73540));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73540)
            ];
        }
    }
});
var defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};
var CustomLottie = function(_param) {
    var width = _param.width, height = _param.height, style = _param.style, isStopped = _param.isStopped, _isClickToPauseDisabled = _param.isClickToPauseDisabled, isClickToPauseDisabled = _isClickToPauseDisabled === void 0 ? true : _isClickToPauseDisabled, eventListeners = _param.eventListeners, customOptions = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "style",
        "isStopped",
        "isClickToPauseDisabled",
        "eventListeners"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Lottie, {
        options: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, defaultOptions, customOptions),
        width: width,
        height: height,
        isStopped: isStopped !== null && isStopped !== void 0 ? isStopped : false,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            margin: 0
        }, style),
        isClickToPauseDisabled: isClickToPauseDisabled,
        eventListeners: eventListeners
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLottie);


/***/ }),

/***/ 8628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports InputLabelStyled, InputLabelRequired */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var InputLabel = function(param) {
    var label = param.label, _labelSpacing = param.labelSpacing, labelSpacing = _labelSpacing === void 0 ? "4px" : _labelSpacing, _required = param.required, required = _required === void 0 ? false : _required;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InputLabelStyled, {
        labelSpacing: labelSpacing,
        children: [
            label,
            required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InputLabelRequired, {
                children: "*"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (InputLabel);
var InputLabelStyled = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-9b6b3f67-0"
})(_templateObject(), function(param) {
    var theme = param.theme, labelSpacing = param.labelSpacing;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.gray700, ";\n    margin-bottom: ").concat(labelSpacing, ";\n    ");
});
var InputLabelRequired = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-9b6b3f67-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.color.red500;
});


/***/ }),

/***/ 11742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports TextareaWrapper, TextareaStyled, LabelWrapper, TextareaLength */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _InputLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8628);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  box-sizing: border-box;\n  border: none;\n  padding: 16px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var TextareaMobile = function(param) {
    var className = param.className, id = param.id, label = param.label, _labelSpacing = param.labelSpacing, labelSpacing = _labelSpacing === void 0 ? "12px" : _labelSpacing, placeholder = param.placeholder, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? 0 : _maxLength, _height = param.height, height = _height === void 0 ? "128px" : _height, value = param.value, onChange = param.onChange, textareaRef = param.textareaRef;
    var onCheckMaxLength = function(object) {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(LabelWrapper, {
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_InputLabel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                        htmlFor: id,
                        label: label,
                        labelSpacing: labelSpacing
                    }),
                    maxLength > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TextareaLength, {
                        labelSpacing: labelSpacing,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                                children: value.length
                            }),
                            " / ",
                            maxLength
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextareaWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextareaStyled, {
                    id: id,
                    ref: textareaRef,
                    height: height,
                    placeholder: placeholder,
                    disabled: disabled,
                    maxLength: maxLength,
                    value: value,
                    onChange: onChange,
                    onInput: onCheckMaxLength
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (TextareaMobile);
var TextareaWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-356de4ed-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray200, ";\n\n    &:focus-within {\n      border-color:").concat(theme.color.gray400, ";\n    }\n  ");
});
var TextareaStyled = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].textarea.withConfig */ .ZP.textarea.withConfig({
    componentId: "sc-356de4ed-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, height = param.height;
    return "\n    ".concat(theme.typography.ARTICLE16R, "\n    color: ").concat(theme.color.gray700, ";\n    height: ").concat(height, ";\n  \n    &::placeholder {\n      ").concat(theme.typography.UI16R, ";\n      color: ").concat(theme.color.gray200, ";\n    }\n  \n    &:focus {\n      border-color: ").concat(theme.color.gray400, ";\n    }\n    \n    &:disabled {\n      color: ").concat(theme.color.gray100, ";\n      background-color: ").concat(theme.color.gray20, ";\n    }\n    ");
});
var LabelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-356de4ed-2"
})(_templateObject2());
var TextareaLength = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-356de4ed-3"
})(_templateObject3(), function(param) {
    var theme = param.theme, labelSpacing = param.labelSpacing;
    return "\n    margin-bottom: ".concat(labelSpacing, ";\n\n    ").concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray400, ";\n    \n    b {\n      ").concat(theme.typography.UI14SB, ";\n      color: ").concat(theme.color.gray600, ";\n    }\n    ");
});


/***/ }),

/***/ 91707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98240);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _DefaultButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47641);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  margin: 0 auto;\n  width: 100%;\n  z-index: 50;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 20px 16px;\n\n  div + div {\n    margin-left: 10px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 32px;\n  width: 100%;\n\n  right: 0;\n  top: -32px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 7;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 12px;\n  padding: 17px;\n  height: 60px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 3;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StickyButton = function(_param) {
    var children = _param.children, _hasGradient = _param.hasGradient, hasGradient = _hasGradient === void 0 ? true : _hasGradient, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "hasGradient"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyButtonContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: "stickyButton"
    }, props), {
        children: [
            hasGradient && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapperGradient, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyButtonWrapper, {
                children: children
            })
        ]
    }));
};
var Button = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
var SubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
var WhiteSubButton = function(_param) /*#__PURE__*/ {
    var text = _param.text, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWhiteSubButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonProps), {
            children: text
        }))
    });
};
StickyButton.Button = Button;
StickyButton.SubButton = SubButton;
StickyButton.WhiteSubButton = WhiteSubButton;
/* harmony default export */ __webpack_exports__["Z"] = (StickyButton);
var StickyButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-0"
})(_templateObject());
var StickyButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    max-width: ".concat(theme.size.tablet, ";\n    background-color: ").concat(theme.color.white, ";\n  ");
});
var StickyButtonWrapperGradient = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-2"
})(_templateObject2());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-3"
})(_templateObject3());
var StyledDefaultButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DefaultButton__WEBPACK_IMPORTED_MODULE_2__/* .DefaultButtonStyled */ .qY).withConfig({
    componentId: "sc-8516f78f-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI18SB, ";\n    background: ").concat(theme.color.primary600, ";\n    color: ").concat(theme.color.white, ";\n  \n    &:disabled {\n      background: ").concat(theme.color.gray200, ";\n    }\n  ");
});
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-8516f78f-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.primary600, ";\n    &: active:not(:disabled) {\n      background: ").concat(theme.color.primary700, ";\n    }\n  ");
});
var SubButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8516f78f-6"
})(_templateObject6());
var StyledSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-8516f78f-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray700, ";\n    &: active {\n      background: ").concat(theme.color.gray800, ";\n    }\n  ");
});
var StyledWhiteSubButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(StyledDefaultButton).withConfig({
    componentId: "sc-8516f78f-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.white, ";\n    color: ").concat(theme.color.gray600, ";\n    border: 1px solid ").concat(theme.color.gray100, ";\n    \n    &: active {\n      background: ").concat(theme.color.white, ";\n    }\n  ");
});


/***/ }),

/***/ 4794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var AlertInformationCircle = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.blue500 */ .Z.color.blue500 : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_3123_59414)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.70893 0.0037226C7.37613 0.0197098 7.16646 0.0379306 6.89933 0.0740906C5.80564 0.222135 4.72396 0.613463 3.77293 1.20518C2.68753 1.88048 1.75169 2.83911 1.10394 3.93917C0.969856 4.16688 0.788212 4.52054 0.685127 4.75461C0.319981 5.58371 0.105479 6.41796 0.0292292 7.30557C0.00730277 7.5608 0.00341797 7.66523 0.00341797 7.99997C0.00341797 8.38046 0.0129412 8.56948 0.0483972 8.89277C0.177127 10.0664 0.575706 11.2152 1.20534 12.2272C1.74277 13.091 2.464 13.8659 3.29613 14.4736C3.94176 14.9451 4.69257 15.3318 5.46253 15.5894C6.06849 15.7921 6.66726 15.916 7.30573 15.9709C7.56097 15.9928 7.6654 15.9967 8.00013 15.9967C8.38062 15.9967 8.56964 15.9872 8.89293 15.9517C10.0665 15.823 11.2154 15.4243 12.2273 14.7948C13.0311 14.2947 13.7568 13.6367 14.3464 12.8736C14.8799 12.1829 15.3085 11.3776 15.5895 10.5376C15.7878 9.94484 15.9111 9.3564 15.9683 8.73013C15.9799 8.60255 15.9937 8.37658 15.9937 8.31234C15.9937 8.27792 15.9966 8.24856 16.0001 8.24637C16.0042 8.24384 16.0065 8.1523 16.0065 7.99281C16.0065 7.82804 16.0044 7.74455 16.0001 7.74717C15.996 7.7497 15.9937 7.72856 15.9937 7.68834C15.9937 7.58311 15.9739 7.30934 15.9518 7.10717C15.8236 5.93509 15.4244 4.78457 14.7949 3.77277C14.2576 2.90911 13.5361 2.13395 12.7041 1.52635C12.0584 1.05476 11.3113 0.669937 10.5377 0.4105C9.88079 0.190167 9.25042 0.0667946 8.51888 0.0153962C8.39123 0.0064298 7.82309 -0.0017558 7.70893 0.0037226ZM7.87213 1.40606C6.51292 1.42624 5.16232 1.88743 4.06413 2.70636C3.55821 3.08363 3.0846 3.55722 2.70648 4.06397C2.28581 4.62772 1.95745 5.26082 1.73222 5.94237C1.55233 6.48676 1.44989 7.03312 1.41425 7.63837C1.39905 7.89653 1.40618 8.30672 1.43082 8.59197C1.51986 9.62289 1.86226 10.6339 2.42457 11.5264C2.76886 12.0728 3.22065 12.5916 3.73453 13.0307C4.75789 13.9053 6.06675 14.4534 7.40813 14.5693C7.78652 14.602 8.21374 14.602 8.59213 14.5693C9.93334 14.4534 11.2425 13.9052 12.2657 13.0307C12.5338 12.8017 12.8019 12.5336 13.0309 12.2656C13.8513 11.3055 14.3854 10.0943 14.5434 8.83517C14.6006 8.37982 14.6095 7.88607 14.5692 7.40797C14.4624 6.14084 13.9543 4.87582 13.1527 3.88157C12.8893 3.55482 12.586 3.24287 12.2657 2.96918C11.2431 2.09531 9.93916 1.54878 8.59533 1.43079C8.38977 1.41274 8.09679 1.40272 7.87213 1.40606ZM7.87965 3.37325C7.73274 3.38743 7.58145 3.43072 7.44517 3.49758C7.09129 3.67116 6.84398 3.99026 6.76086 4.38055C6.73851 4.48549 6.7324 4.69502 6.74846 4.80637C6.8087 5.22436 7.06945 5.58309 7.44653 5.76676C7.79677 5.93736 8.20349 5.93736 8.55373 5.76676C8.92838 5.58427 9.19103 5.22462 9.25104 4.81195C9.26397 4.72297 9.26395 4.54692 9.251 4.45402C9.21497 4.19572 9.09763 3.95371 8.91469 3.76045C8.65096 3.48183 8.26202 3.33634 7.87965 3.37325ZM6.73893 6.74898C6.51919 6.78923 6.31386 6.95852 6.22708 7.17099C6.18735 7.26825 6.17925 7.31494 6.17985 7.44317C6.18032 7.54333 6.18218 7.56192 6.19748 7.61911C6.22842 7.73482 6.28308 7.83035 6.37066 7.92173C6.48369 8.03969 6.60746 8.10635 6.75907 8.13094C6.80535 8.13845 6.87461 8.14072 7.05773 8.14074L7.29613 8.14077V9.40453V10.6683L6.74093 10.6704C6.19184 10.6726 6.18519 10.6728 6.13693 10.6866C5.94878 10.7407 5.79228 10.8637 5.69869 11.0311C5.59588 11.2149 5.58619 11.4594 5.67386 11.6576C5.71277 11.7455 5.80762 11.8645 5.88813 11.9263C5.94313 11.9685 6.02053 12.0107 6.08156 12.0318C6.19988 12.0726 6.08407 12.0703 8.00013 12.0703C9.91619 12.0703 9.80038 12.0726 9.91869 12.0318C10.0569 11.984 10.1865 11.881 10.2737 11.7498C10.3341 11.6588 10.3666 11.5691 10.3812 11.4534C10.4049 11.2648 10.3497 11.0711 10.2319 10.9295C10.129 10.8059 10.0135 10.7298 9.86333 10.6866C9.81507 10.6728 9.80842 10.6726 9.25933 10.6704L8.70413 10.6683V9.04638C8.70413 7.89962 8.70204 7.40517 8.69701 7.35861C8.67892 7.19131 8.61901 7.06923 8.49333 6.9436C8.39197 6.84229 8.31923 6.79935 8.17613 6.75636C8.13197 6.74309 8.12177 6.74288 7.45933 6.74151C6.90973 6.74037 6.77851 6.74173 6.73893 6.74898ZM0.00341797 7.99997C0.00341797 8.13901 0.00388517 8.19588 0.00492197 8.12637C0.00595237 8.05685 0.00595237 7.94308 0.00492197 7.87357C0.00388517 7.80405 0.00341797 7.86093 0.00341797 7.99997Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3123_59414",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AlertInformationCircle);


/***/ }),

/***/ 78972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44376);
/* harmony import */ var _types_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: transform 0.1s linear;\n  transform: rotate(\n    ",
        "deg\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/**
 * @default
 * direction: DIRECTION.RIGHT,
 * color: theme.color.primary500,
 * size: 16,
 */ var ArrowCaret = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.RIGHT */ .JR.RIGHT : _direction, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].color.primary500 */ .Z.color.primary500 : _color, _size = param.size, size = _size === void 0 ? 16 : _size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ArrowSVG, {
        direction: direction,
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.1782 7.635C11.3849 7.83656 11.3849 8.16336 11.1782 8.36492L6.23701 13.1821C6.03027 13.3837 5.69506 13.3837 5.48831 13.1821C5.28157 12.9806 5.28157 12.6538 5.48831 12.4522L10.0551 7.99996L5.48831 3.54771C5.28157 3.34615 5.28157 3.01936 5.48831 2.8178C5.69506 2.61624 6.03027 2.61624 6.23702 2.8178L11.1782 7.635Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowCaret);
var ArrowSVG = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-73a165d0-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.TOP */ .JR.TOP ? -90 : direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.BOTTOM */ .JR.BOTTOM ? 90 : direction === _types_common__WEBPACK_IMPORTED_MODULE_3__/* .DIRECTION.LEFT */ .JR.LEFT ? 180 : 0;
});


/***/ }),

/***/ 57471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


var Delete = function(param) {
    var _size = param.size, size = _size === void 0 ? 12 : _size, _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.white */ .Z.color.white : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_3124_59447)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0.43043 0.00723253C0.319339 0.0282085 0.227928 0.0786373 0.145982 0.164149C0.0804524 0.23253 0.0393644 0.304607 0.0155756 0.392903C0.00435802 0.434533 0.00313402 0.447575 0.00313402 0.525474C0.00313402 0.603791 0.00432922 0.616367 0.015902 0.659874C0.0311324 0.717138 0.0666476 0.791159 0.101107 0.837474C0.115608 0.856962 1.20287 1.9481 2.68988 3.43547L5.25366 5.99987L2.68988 8.56427C1.20287 10.0516 0.115608 11.1428 0.101107 11.1623C0.0666476 11.2086 0.0311324 11.2826 0.015902 11.3399C0.00432922 11.3834 0.00313402 11.396 0.00313402 11.4743C0.00313402 11.5522 0.00435802 11.5652 0.0155756 11.6068C0.0643388 11.7878 0.211675 11.9356 0.391627 11.984C0.434947 11.9957 0.447153 11.9968 0.525686 11.9968C0.604003 11.9968 0.616579 11.9956 0.660086 11.9841C0.71735 11.9688 0.791371 11.9333 0.837686 11.8989C0.857174 11.8844 1.94831 10.7971 3.43569 9.31008L6.00009 6.7463L8.56449 9.31008C10.0519 10.7971 11.143 11.8844 11.1625 11.8989C11.2088 11.9333 11.2828 11.9688 11.3401 11.9841C11.3836 11.9956 11.3962 11.9968 11.4745 11.9968C11.553 11.9968 11.5652 11.9957 11.6085 11.984C11.7568 11.9441 11.8898 11.8313 11.9551 11.6899C11.9727 11.6519 11.9953 11.5722 11.9953 11.5483C11.9953 11.5409 11.9974 11.5335 12.0001 11.5319C12.0029 11.5302 12.0049 11.5037 12.0049 11.4689C12.0049 11.4301 12.0032 11.41 12.0001 11.4119C11.9973 11.4136 11.9953 11.4089 11.9953 11.4008C11.9953 11.393 11.9899 11.3654 11.9834 11.3393C11.9693 11.2831 11.9343 11.2097 11.8991 11.1623C11.8846 11.1428 10.7973 10.0516 9.31029 8.56427L6.74651 5.99987L9.31029 3.43547C10.7973 1.9481 11.8846 0.856962 11.8991 0.837474C11.9343 0.790088 11.9693 0.716682 11.9834 0.66046C11.9899 0.634381 11.9953 0.606968 11.9953 0.599543C11.9953 0.592117 11.9974 0.584706 12.0001 0.583074C12.0029 0.581351 12.0049 0.554932 12.0049 0.520108C12.0049 0.481329 12.0032 0.461159 12.0001 0.463074C11.9973 0.464792 11.9953 0.460127 11.9953 0.451972C11.9953 0.424468 11.9711 0.343093 11.95 0.299807C11.8829 0.161802 11.7541 0.0549733 11.6071 0.0153637C11.5654 0.00414613 11.5524 0.00292213 11.4745 0.00292213C11.3962 0.00292213 11.3836 0.00411733 11.3401 0.0156901C11.2828 0.0309205 11.2088 0.0664357 11.1625 0.100895C11.143 0.115396 10.0519 1.20266 8.56449 2.68967L6.00009 5.25345L3.43569 2.68967C1.94831 1.20266 0.857174 0.115396 0.837686 0.100895C0.790814 0.0660181 0.716966 0.0307477 0.660086 0.0160741C0.598996 0.000310933 0.489427 -0.00390827 0.43043 0.00723253ZM0.00195322 0.525474C0.00195802 0.559794 0.00272602 0.573205 0.00364761 0.555272C0.00457401 0.537344 0.00456922 0.509264 0.00363322 0.492872C0.00270202 0.476485 0.00194362 0.491154 0.00195322 0.525474ZM0.00195322 11.4743C0.00195802 11.5086 0.00272602 11.522 0.00364761 11.5041C0.00457401 11.4861 0.00456922 11.4581 0.00363322 11.4417C0.00270202 11.4253 0.00194362 11.44 0.00195322 11.4743Z",
                    fill: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_3124_59447",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Delete);


/***/ }),

/***/ 79409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Dot = function(param) {
    var _color = param.color, color = _color === void 0 ? "#A9AEB1" : _color, _size = param.size, size = _size === void 0 ? 3 : _size, areaWidth = param.areaWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSvg, {
        width: size,
        height: size,
        areaWidth: areaWidth,
        viewBox: "0 0 3 3",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
            cx: "1.5",
            cy: "1.5",
            r: "1.5",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dot);
var StyledSvg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-aa1e3d24-0"
})(_templateObject(), function(param) {
    var areaWidth = param.areaWidth;
    return "width: ".concat(areaWidth, "px");
});


/***/ }),

/***/ 95699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44376);


/**
 * @default
 * color: theme.color.black
 * width: 18
 * height: 18
 * strokeWidth: 1.5
 */ var Plus = function(param) {
    var _color = param.color, color = _color === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* ["default"].color.black */ .Z.color.black : _color, _width = param.width, width = _width === void 0 ? 18 : _width, _height = param.height, height = _height === void 0 ? 18 : _height, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 1.5 : _strokeWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3 9H15",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 3V15",
                stroke: color,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Plus);


/***/ }),

/***/ 12906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44376);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ReportCheckBox = function(param) {
    var isChecked = param.isChecked, _marginRight = param.marginRight, marginRight = _marginRight === void 0 ? 0 : _marginRight;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        marginRight: marginRight,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: isChecked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                        width: "22",
                        height: "22",
                        rx: "4",
                        fill: "#FF8D00"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
                        clipPath: "url(#clip0_3378_52888)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M15.9633 5.81458C15.7311 5.83212 15.525 5.92307 15.3653 6.07857C15.3414 6.10184 15.2744 6.17812 15.2164 6.24808C15.1584 6.31804 13.6716 8.11732 11.9124 10.2465C10.1532 12.3756 8.71046 14.1214 8.70622 14.1259C8.69906 14.1335 8.62878 14.0444 7.71451 12.8685C7.17331 12.1724 6.71258 11.5819 6.69067 11.5563C6.53618 11.3754 6.32521 11.2671 6.07051 11.2379C5.77992 11.2046 5.50387 11.3009 5.28881 11.5108C5.20188 11.5956 5.142 11.6779 5.09396 11.7785C5.02658 11.9195 4.99631 12.071 5.00156 12.2409C5.00779 12.4424 5.06386 12.6026 5.18713 12.7713C5.21912 12.815 7.29929 15.4899 7.35403 15.5577C7.40303 15.6183 7.5179 15.7341 7.57864 15.784C8.0146 16.1425 8.57816 16.2699 9.12492 16.1335C9.45932 16.05 9.77213 15.8579 10.0038 15.5937C10.0451 15.5465 16.7301 7.45789 16.7906 7.38192C16.8943 7.25151 16.9607 7.10558 16.9887 6.94648C17.0002 6.88059 17.0025 6.74041 16.9932 6.66437C16.9649 6.43317 16.8738 6.24877 16.7091 6.08951C16.5028 5.89011 16.241 5.79362 15.9633 5.81458Z",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                            id: "clip0_3378_52888",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                                width: "12",
                                height: "12",
                                fill: "white",
                                transform: "translate(5 5)"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("rect", {
                x: "1",
                y: "1",
                width: "20",
                height: "20",
                rx: "3",
                stroke: _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].color.gray100 */ .Z.color.gray100,
                strokeWidth: "2"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReportCheckBox);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-681f0aa1-0"
})(_templateObject(), function(param) {
    var marginRight = param.marginRight;
    return marginRight;
});


/***/ }),

/***/ 80138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85244);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_atom_Tab_LineTab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11466);
/* harmony import */ var _components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39535);





var CategoryBottomSheet = function(param) {
    var isVisible = param.isVisible, categoryGroup = param.categoryGroup, selectedTab = param.selectedTab, onClickCategoriesBottomSheetTab = param.onClickCategoriesBottomSheetTab, toggleBottomSheet = param.toggleBottomSheet, onClickCategoryItem = param.onClickCategoryItem, getSelectedTabItemList = param.getSelectedTabItemList;
    if (!categoryGroup) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        index: 10,
        isOpened: isVisible,
        onClickOverlay: function() {
            return toggleBottomSheet(false);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Tabs */ .ZP.Tabs, {
            tabs: categoryGroup.tabs,
            selectedTab: selectedTab,
            activeColor: _components_atom_Tab_LineTab__WEBPACK_IMPORTED_MODULE_1__/* .LINE_TAB_COLOR.BLACK */ .r.BLACK,
            inActiveColor: _components_atom_Tab_LineTab__WEBPACK_IMPORTED_MODULE_1__/* .LINE_TAB_COLOR.GREY */ .r.GREY,
            onClickTab: function(tab) {
                return onClickCategoriesBottomSheetTab((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, tab), {
                    value: tab.value
                }));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Tabs.List */ .ZP.Tabs.List, {
                items: getSelectedTabItemList(),
                onClickItem: onClickCategoryItem
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoryBottomSheet);


/***/ }),

/***/ 95392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4480);
/* harmony import */ var _hooks_useScreenFocus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50341);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4415);
/* harmony import */ var _recoil_atoms_common_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3818);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10712);






var useSetAuthOnScreenFocus = function() {
    var focused = (0,_hooks_useScreenFocus__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var setToken = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_3__/* .tokenState */ .J1);
    var setUser = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_user__WEBPACK_IMPORTED_MODULE_4__/* .userState */ .KL);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_5__/* .isWebView */ .vp)()) {
            if (!(window === null || window === void 0 ? void 0 : window.appToken) || (window === null || window === void 0 ? void 0 : window.appToken) === "undefined") {
                setToken("");
            } else {
                setToken(window.appToken);
            }
            if (!(window === null || window === void 0 ? void 0 : window.appUser) || (window === null || window === void 0 ? void 0 : window.appUser) === "undefined") {
                setUser(undefined);
            } else {
                setUser(JSON.parse(window.appUser));
            }
        }
    }, [
        focused,
        setToken,
        setUser
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useSetAuthOnScreenFocus);


/***/ }),

/***/ 47863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4365);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4415);





var useGetMyUncheckedAiAnswer = function() {
    var token = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilValue)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_2__/* .tokenState */ .J1);
    var ref = (0,_hooks_qna_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useGetMyUncheckedQuestionQuery */ .Eg)({}, {
        useErrorBoundary: false,
        refetchOnWindowFocus: true,
        retry: 0,
        enabled: !!token
    }), data = ref.data, refetch = ref.refetch;
    var unCheckedMyAiQuestion = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            refetch()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function unCheckedMyAiQuestion() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!(data === null || data === void 0 ? void 0 : data.myUncheckedQuestion)) {
        return null;
    }
    var _myUncheckedQuestion = data.myUncheckedQuestion, aiAnswerStatus = _myUncheckedQuestion.aiAnswerStatus, questionPid = _myUncheckedQuestion.questionPid, status = _myUncheckedQuestion.status;
    return {
        aiAnswerStatus: aiAnswerStatus,
        questionPid: questionPid,
        unCheckedMyAiQuestion: unCheckedMyAiQuestion,
        status: status
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetMyUncheckedAiAnswer);


/***/ }),

/***/ 85978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22970);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _hooks_useToast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17722);




var useQnaWriteBottomSheetGroup = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), activeBottomSheetType = ref[0], setActiveBottomSheetType = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isGeolocationLoading = ref1[0], setIsGeolocationLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isCheckedAgreement = ref2[0], setIsCheckedAgreement = ref2[1];
    var showToast = (0,_hooks_useToast__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().showToast;
    var setApproveAgreement = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                return [
                    2
                ];
            });
        // if (!agreementData) return;
        //
        // await setApproveAgreementMutate({
        //   request: {
        //     approvedAgreementIds: [Number(agreementData.id)],
        //     disapprovedAgreementIds: [],
        //   },
        // });
        });
        return function setApproveAgreement() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeBottomSheetType = function(type) {
        if (!type) {
            return setActiveBottomSheetType(undefined);
        }
        setActiveBottomSheetType(type);
    };
    var onChangeAgreement = function() {
        setIsCheckedAgreement(function(prev) {
            return !prev;
        });
    };
    var onOpenGeolocationTerms = function() {
    // if (!agreementData) return;
    // if (isWebView()) {
    //   return sendPostMessageToNative(
    //     NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER,
    //     {
    //       url: agreementData.url as string,
    //     },
    //   );
    // }
    // window.open(agreementData.url as string, '_blank');
    };
    var requestGeolocation = function(param) {
        var onSuccess = param.onSuccess, onError = param.onError;
        setIsGeolocationLoading(true);
        navigator.geolocation.getCurrentPosition(function(param) {
            var coords = param.coords;
            onChangeBottomSheetType();
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess({
                latitude: coords.latitude,
                longitude: coords.longitude
            });
        }, function() {
            if (onError) {
                return onError();
            }
            showToast({
                message: "위치 사용을 허용해야 내 위치 설정이 가능해요"
            });
            setIsGeolocationLoading(false);
            onChangeBottomSheetType();
        }, {
            enableHighAccuracy: true,
            timeout: 10000
        });
    };
    return {
        onOpenGeolocationTerms: onOpenGeolocationTerms,
        requestGeolocation: requestGeolocation,
        isGeolocationLoading: isGeolocationLoading,
        isApprovedByLocationCategory: true,
        setApproveAgreement: setApproveAgreement,
        activeBottomSheetType: activeBottomSheetType,
        onChangeBottomSheetType: onChangeBottomSheetType,
        isCheckedAgreement: isCheckedAgreement,
        onChangeAgreement: onChangeAgreement,
        isAiAgreementNeeded: true
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useQnaWriteBottomSheetGroup);


/***/ }),

/***/ 62139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _parsers_qna__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65083);
/* harmony import */ var _mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4365);


var useGetQnaCategoryGroup = function() {
    var ref = (0,_mobile_qna_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useGetQnaCategoryGroupQuery */ .Tb)({}, {
        select: _parsers_qna__WEBPACK_IMPORTED_MODULE_0__/* .parseQnaCategoryGroup */ .ZA
    }), categoryGroup = ref.data;
    return {
        categoryGroup: categoryGroup
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetQnaCategoryGroup);


/***/ }),

/***/ 71213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _components_molecules_LoginModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4329);
/* harmony import */ var _hooks_useModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98266);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74701);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10712);








var useAuthModal = function() {
    var canOverlayClick = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, isWritePage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showAuthModal = ref[0], setShowAuthModal = ref[1];
    var ref1 = (0,_hooks_useModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        campaign: "",
        content: "",
        buttonText: ""
    }), trackInfo = ref2[0], setTrackInfo = ref2[1];
    var isRouteBackPath = router.pathname.includes("/content/qna/write");
    var onClickCancel = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setShowAuthModal(false);
        closeModal();
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)() && isRouteBackPath) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .historyBack */ .$i)();
        }
    }, [
        closeModal,
        isRouteBackPath
    ]);
    /** for Webview  */ var onClickLogin = function() {
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .sendPostMessageToNative */ .T0)(_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_LOGIN */ .nn.MOVE_TO_LOGIN);
            setShowAuthModal(false);
            closeModal();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (showAuthModal) {
            (0,_utils_logger__WEBPACK_IMPORTED_MODULE_6__/* .logger */ .kg)({
                eventName: "sns_login",
                pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_6__/* .getPageName */ .j0)(router)
            });
            if (!(0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_7__/* .isWebView */ .vp)()) {
                showModal({
                    type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_TYPE.BASIC */ .f.BASIC,
                    props: {
                        body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_molecules_LoginModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            isWritePage: isWritePage,
                            onClick: onClickCancel,
                            trackInfo: trackInfo
                        }),
                        onClickOverlay: canOverlayClick ? onClickCancel : undefined
                    }
                });
            } else {
                showModal({
                    type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_TYPE.ALERT */ .f.ALERT,
                    props: {
                        title: "로그인이 필요해요",
                        message: "서비스 이용을 위해 로그인해 주세요.",
                        buttons: [
                            {
                                label: "닫기",
                                onClick: function() {
                                    return onClickCancel();
                                }
                            },
                            {
                                type: _types_modal__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_BUTTON_TYPE.PRIMARY */ .J.PRIMARY,
                                label: "로그인",
                                onClick: function() {
                                    return onClickLogin();
                                }
                            }, 
                        ]
                    }
                });
            }
        }
    }, [
        showAuthModal
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var close = function() {
            closeModal();
        };
        window.addEventListener("popstate", close);
        return function() {
            window.removeEventListener("popstate", close);
        };
    });
    return {
        setShowAuthModal: setShowAuthModal,
        setTrackInfo: setTrackInfo,
        trackInfo: trackInfo
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModal);


/***/ }),

/***/ 77196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62230);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12436);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78287);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);






var useCustomRouter = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var moveToPage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(param) {
        var webLink = param.webLink, mobileScreenName = param.mobileScreenName, params = param.params, as = param.as, _type = param.type, type = _type === void 0 ? _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */ .nn.MOVE_TO_PAGE : _type;
        if ((0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .sendPostMessageToNative */ .T0)(type, {
                screenName: mobileScreenName,
                params: params ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params) : undefined
            });
        } else {
            if (!webLink) return;
            if (type === _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */ .nn.REPLACE_TO_PAGE) {
                router.replace(webLink, as);
                return;
            }
            router.push(webLink, as);
        }
    }, [
        router
    ]);
    var getCustomPageName = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(defaultPageName) {
        return (0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)() ? defaultPageName : (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getMobileWebPageName */ .b9)(router);
    }, [
        router
    ]);
    var pageName = (0,_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .getPageName */ .j0)(router);
    return {
        router: router,
        moveToPage: lodash_throttle__WEBPACK_IMPORTED_MODULE_0___default()(moveToPage, 1500, {
            trailing: false
        }),
        getCustomPageName: getCustomPageName,
        pageName: pageName
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCustomRouter);


/***/ }),

/***/ 38102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4415);
/* harmony import */ var _services_community__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29178);
/* harmony import */ var _auth_useSetAuthOnScreenFocus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95392);
/* harmony import */ var _community_mobile_community_gql_impl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42549);





var useGetCommunityUser = function() {
    (0,_auth_useSetAuthOnScreenFocus__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var token = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilValue)(_recoil_atoms_common_auth__WEBPACK_IMPORTED_MODULE_1__/* .tokenState */ .J1);
    // 유저 정보 가져오기
    var ref = (0,_community_mobile_community_gql_impl__WEBPACK_IMPORTED_MODULE_4__/* .useGetCommunityUserQuery */ .K_)({}, {
        enabled: !!token,
        select: function(data) {
            return (0,_services_community__WEBPACK_IMPORTED_MODULE_2__/* .communityUserService */ .mT)(data);
        }
    }), userProfile = ref.data;
    return {
        userProfile: userProfile
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetCommunityUser);


/***/ }),

/***/ 98266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85244);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22386);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81541);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var _recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11221);
/* harmony import */ var _types_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74701);







var useModal = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_0__.useRecoilState)(_recoil_atoms_common_modal__WEBPACK_IMPORTED_MODULE_1__/* .modalState */ .e), 2), modals = ref[0], setModals = ref[1];
    var addModal = function(modal) {
        setModals(function(oldModals) {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(oldModals).concat([
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, modal), {
                    index: oldModals.length + 1
                }), 
            ]);
        });
    };
    var showModal = function(param) {
        var type = param.type, props = param.props;
        switch(type){
            case _types_modal__WEBPACK_IMPORTED_MODULE_2__/* .MODAL_TYPE.BASIC */ .f.BASIC:
            default:
                addModal({
                    type: type,
                    props: props
                });
                break;
        }
    };
    var closeModal = function() {
        var tempModals = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(modals);
        tempModals.pop();
        setModals(tempModals);
    };
    return {
        isModalOpen: modals.length > 0,
        showModal: showModal,
        closeModal: closeModal
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useModal);


/***/ }),

/***/ 45889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4480);
/* harmony import */ var _hooks_useWindowFocus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97167);
/* harmony import */ var _recoil_atoms_common_neverSeeAgain__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92080);
/* harmony import */ var _utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10712);





var useNeverSeeAgain = function() {
    var focused = (0,_hooks_useWindowFocus__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var setNeverSeeAgain = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_neverSeeAgain__WEBPACK_IMPORTED_MODULE_3__/* .neverSeeAgainState */ .b);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!(0,_utils_mobile_RNPlugins__WEBPACK_IMPORTED_MODULE_4__/* .isWebView */ .vp)()) {
            return;
        }
        if (!(window === null || window === void 0 ? void 0 : window.neverSeeAgainState) || (window === null || window === void 0 ? void 0 : window.neverSeeAgainState) === "undefined") {
            setNeverSeeAgain({});
        } else {
            setNeverSeeAgain(JSON.parse(window.neverSeeAgainState));
        }
    }, [
        focused,
        setNeverSeeAgain
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useNeverSeeAgain);


/***/ }),

/***/ 50341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var hasFocus = function() {
    return typeof document !== "undefined" && document.hasFocus();
};
var useScreenFocus = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(hasFocus), focused = ref[0], setFocused = ref[1]; // Focus for first render
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var androidFocusHandler = function(event) {
            if (event.data && Object.keys(JSON.parse(event.data)).includes("isFocused")) {
                setFocused(JSON.parse(event.data).isFocused);
            }
        };
        document.addEventListener("message", androidFocusHandler);
        return function() {
            document.removeEventListener("message", androidFocusHandler);
        };
    }, []);
    return focused;
};
/* harmony default export */ __webpack_exports__["Z"] = (useScreenFocus);


/***/ }),

/***/ 17722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54073);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4480);
/* harmony import */ var _recoil_atoms_common_toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15094);



var useToast = function() {
    var setToasts = (0,recoil__WEBPACK_IMPORTED_MODULE_1__.useSetRecoilState)(_recoil_atoms_common_toast__WEBPACK_IMPORTED_MODULE_2__/* .toastState */ .J);
    var removeToast = function(id) {
        setToasts(function(oldToasts) {
            return oldToasts.filter(function(toast) {
                return toast.id !== id;
            });
        });
    };
    var _showToast = function(props) {
        var id = new Date().getTime();
        setToasts([
            {
                props: props,
                id: id
            }
        ]);
        return setTimeout(function() {
            return removeToast(id);
        }, (props.visibleTime || 2000) + 800);
    };
    var showToast = lodash_debounce__WEBPACK_IMPORTED_MODULE_0___default()(_showToast, 300);
    return {
        showToast: showToast
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useToast);


/***/ }),

/***/ 97167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
// ref: https://github.com/jpalumickas/use-window-focus

var hasFocus = function() {
    return typeof document !== "undefined" && document.hasFocus();
};
var useWindowFocus = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(hasFocus), focused = ref[0], setFocused = ref[1]; // Focus for first render
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setFocused(hasFocus()); // Focus for additional renders
        var onFocus = function() {
            return setFocused(true);
        };
        var onFocusOut = function() {
            return setFocused(false);
        };
        // AOS focusin / focusout
        window.addEventListener("focusin", onFocus);
        window.addEventListener("focusout", onFocusOut);
        // IOS focus / blur
        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onFocusOut);
        return function() {
            window.removeEventListener("focusin", onFocus);
            window.removeEventListener("focusout", onFocusOut);
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onFocusOut);
        };
    }, []);
    return focused;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowFocus);


/***/ }),

/***/ 84958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ Review; },
/* harmony export */   "Fj": function() { return /* binding */ EReviewType; },
/* harmony export */   "IE": function() { return /* binding */ ReviewComment; },
/* harmony export */   "R": function() { return /* binding */ ReviewDiagnosisDoctor; },
/* harmony export */   "Vj": function() { return /* binding */ ReviewTag; },
/* harmony export */   "XV": function() { return /* binding */ ReviewTagExposure; },
/* harmony export */   "fr": function() { return /* binding */ ReviewTargetType; }
/* harmony export */ });
/* unused harmony exports MedicineType, ReviewDiagnosis */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95210);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15386);


var ReviewTargetType;
(function(ReviewTargetType) {
    ReviewTargetType["DOCTOR"] = "DOCTOR";
    ReviewTargetType["PHARMACY"] = "PHARMACY";
})(ReviewTargetType || (ReviewTargetType = {}));
var EReviewType;
(function(EReviewType) {
    EReviewType["NORMAL"] = "NORMAL";
    EReviewType["BEST"] = "BEST";
})(EReviewType || (EReviewType = {}));
var MedicineType;
(function(MedicineType) {
    MedicineType["Counselor"] = "COUNSELOR";
    MedicineType["Dentist"] = "DENTIST";
    MedicineType["Doctor"] = "DOCTOR";
    MedicineType["OrientalDoctor"] = "ORIENTAL_DOCTOR";
})(MedicineType || (MedicineType = {}));
var Review = /*#__PURE__*/ function() {
    "use strict";
    function Review(review) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Review);
        this.review = review;
    }
    var _proto = Review.prototype;
    _proto.shouldNotDisplayed = function shouldNotDisplayed(currentUserId) {
        if (!this.isPrivate) {
            return false;
        }
        return Number(currentUserId) !== Number(this.userId);
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Review, [
        {
            key: "id",
            get: function get() {
                return this.review.id;
            }
        },
        {
            key: "isPrivate",
            get: function get() {
                return this.review.isPrivate;
            }
        },
        {
            key: "userId",
            get: function get() {
                return this.review.userId;
            }
        },
        {
            key: "isLiked",
            get: function get() {
                return this.review.isLiked;
            }
        },
        {
            key: "title",
            get: function get() {
                return this.review.title;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.review.content;
            }
        },
        {
            key: "writer",
            get: function get() {
                return this.review.writer;
            }
        },
        {
            key: "rating",
            get: function get() {
                return this.review.rating;
            }
        },
        {
            key: "comment",
            get: function get() {
                return this.review.comment;
            }
        },
        {
            key: "likeCount",
            get: function get() {
                return this.review.likeCount;
            }
        },
        {
            key: "tags",
            get: function get() {
                return this.review.tags;
            }
        },
        {
            key: "price",
            get: function get() {
                return this.review.price;
            }
        },
        {
            key: "createdAt",
            get: function get() {
                return this.review.createdAt;
            }
        },
        {
            key: "diagnosisCategoryName",
            get: function get() {
                return this.review.diagnosisCategoryName;
            }
        },
        {
            key: "doctor",
            get: function get() {
                return this.review.doctor;
            }
        }
    ]);
    return Review;
}();
var ReviewTag = /*#__PURE__*/ function() {
    "use strict";
    function ReviewTag(tag) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewTag);
        this.tag = tag;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewTag, [
        {
            key: "reviewId",
            get: function get() {
                return this.tag.reviewId;
            }
        },
        {
            key: "tagId",
            get: function get() {
                return this.tag.tagId;
            }
        },
        {
            key: "text",
            get: function get() {
                return this.tag.text;
            }
        }
    ]);
    return ReviewTag;
}();
var ReviewComment = /*#__PURE__*/ function() {
    "use strict";
    function ReviewComment(reviewComment) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewComment);
        this.reviewComment = reviewComment;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewComment, [
        {
            key: "createdAt",
            get: function get() {
                return this.reviewComment.createdAt;
            }
        },
        {
            key: "content",
            get: function get() {
                return this.reviewComment.content;
            }
        }
    ]);
    return ReviewComment;
}();
var ReviewDiagnosis = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function ReviewDiagnosis(reviewDiagnosis) {
        _class_call_check(this, ReviewDiagnosis);
        this.reviewDiagnosis = reviewDiagnosis;
    }
    _create_class(ReviewDiagnosis, [
        {
            key: "doctor",
            get: function get() {
                return this.reviewDiagnosis.doctor;
            }
        }
    ]);
    return ReviewDiagnosis;
}()));
var ReviewDiagnosisDoctor = /*#__PURE__*/ function() {
    "use strict";
    function ReviewDiagnosisDoctor(reviewDiagnosisDoctor) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ReviewDiagnosisDoctor);
        this.reviewDiagnosisDoctor = reviewDiagnosisDoctor;
    }
    var _proto = ReviewDiagnosisDoctor.prototype;
    _proto.getDoctorDisplayName = function getDoctorDisplayName() {
        if (this.medicineType === MedicineType.OrientalDoctor) {
            return "".concat(this.name, " 한의사");
        }
        return "".concat(this.name, " 의사");
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ReviewDiagnosisDoctor, [
        {
            key: "id",
            get: function get() {
                return this.reviewDiagnosisDoctor.id;
            }
        },
        {
            key: "medicineType",
            get: function get() {
                return this.reviewDiagnosisDoctor.medicineType;
            }
        },
        {
            key: "name",
            get: function get() {
                return this.reviewDiagnosisDoctor.name;
            }
        },
        {
            key: "profile",
            get: function get() {
                return this.reviewDiagnosisDoctor.profile;
            }
        }
    ]);
    return ReviewDiagnosisDoctor;
}();
var ReviewTagExposure;
(function(ReviewTagExposure) {
    ReviewTagExposure["ALWAYS"] = "ALWAYS";
    ReviewTagExposure["POSITIVE"] = "POSITIVE";
    ReviewTagExposure["NEGATIVE"] = "NEGATIVE";
    ReviewTagExposure["NONE"] = "NONE";
})(ReviewTagExposure || (ReviewTagExposure = {}));


/***/ }),

/***/ 74390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ write; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(92563);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
;// CONCATENATED MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_throw.mjs
function _throw(e) {
    throw e;
}
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/assets/lottie/bubble-ask.json
var bubble_ask_namespaceObject = JSON.parse('{"ddd":0,"fr":60,"h":40,"ip":0,"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"","ln":"GruDTENQZECgBNCBWe5AF","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[0.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[6.71],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[12.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[18.16],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[23.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[28.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[33.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[38.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[42.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[46.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[50.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[54.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[58.23],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[61.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[64.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[67.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[70.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[73.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[75.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[78.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[80.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[82.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[84.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[86.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[87.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[89.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[90.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[91.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":76,"s":[92.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":77,"s":[93.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":78,"s":[94.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":79,"s":[95.68],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":80,"s":[96.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":81,"s":[97.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":82,"s":[97.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":83,"s":[98.09],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":84,"s":[98.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":85,"s":[98.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":86,"s":[99.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":87,"s":[99.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":88,"s":[99.57],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":89,"s":[99.71],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":90,"s":[99.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":91,"s":[99.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":92,"s":[99.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":93,"s":[99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":94,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":95,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":169,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":170,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":171,"s":[99.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":172,"s":[99.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":173,"s":[99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":174,"s":[99.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":175,"s":[99.63],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":176,"s":[99.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":177,"s":[99.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":178,"s":[98.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":179,"s":[98.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":180,"s":[98.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":181,"s":[97.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":182,"s":[97.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":183,"s":[96.68],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":184,"s":[95.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":185,"s":[95.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":186,"s":[94.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":187,"s":[93.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":188,"s":[92.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":189,"s":[91.09],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":190,"s":[89.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":191,"s":[88.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":192,"s":[86.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":193,"s":[85.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":194,"s":[83.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":195,"s":[81.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":196,"s":[79.17],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":197,"s":[76.89],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":198,"s":[74.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":199,"s":[71.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":200,"s":[69.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":201,"s":[66.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":202,"s":[62.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":203,"s":[59.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":204,"s":[56.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":205,"s":[52.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":206,"s":[48.51],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":207,"s":[44.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":208,"s":[40.04],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":209,"s":[35.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":210,"s":[30.68],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":211,"s":[25.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":212,"s":[20.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":213,"s":[14.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":214,"s":[9.16],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":215,"s":[3.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":0,"k":[29,20]},"r":{"a":0,"k":0},"s":{"a":1,"k":[{"t":0,"s":[50,50],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[50,50],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[50.3,50.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[53.35,53.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[56.28,56.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[59.08,59.08],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[61.76,61.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[64.32,64.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[66.76,66.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[69.09,69.09],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[71.31,71.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[73.42,73.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[75.42,75.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[77.32,77.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[79.12,79.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[80.82,80.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[82.42,82.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[83.94,83.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[85.36,85.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[86.7,86.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[87.95,87.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[89.13,89.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[90.22,90.22],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[91.24,91.24],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[92.18,92.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[93.06,93.06],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":72,"s":[93.86,93.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":73,"s":[94.6,94.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":74,"s":[95.28,95.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":75,"s":[95.9,95.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":76,"s":[96.46,96.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":77,"s":[96.97,96.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":78,"s":[97.43,97.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":79,"s":[97.84,97.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":80,"s":[98.2,98.2],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":81,"s":[98.52,98.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":82,"s":[98.8,98.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":83,"s":[99.04,99.04],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":84,"s":[99.25,99.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":85,"s":[99.43,99.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":86,"s":[99.57,99.57],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":87,"s":[99.69,99.69],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":88,"s":[99.78,99.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":89,"s":[99.86,99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":90,"s":[99.91,99.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":91,"s":[99.95,99.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":92,"s":[99.97,99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":93,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":94,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":169,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":170,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":171,"s":[99.97,99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":172,"s":[99.94,99.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":173,"s":[99.89,99.89],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":174,"s":[99.82,99.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":175,"s":[99.72,99.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":176,"s":[99.6,99.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":177,"s":[99.43,99.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":178,"s":[99.23,99.23],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":179,"s":[98.99,98.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":180,"s":[98.7,98.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":181,"s":[98.36,98.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":182,"s":[97.96,97.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":183,"s":[97.51,97.51],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":184,"s":[96.99,96.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":185,"s":[96.41,96.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":186,"s":[95.75,95.75],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":187,"s":[95.02,95.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":188,"s":[94.21,94.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":189,"s":[93.32,93.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":190,"s":[92.34,92.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":191,"s":[91.26,91.26],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":192,"s":[90.1,90.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":193,"s":[88.83,88.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":194,"s":[87.45,87.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":195,"s":[85.97,85.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":196,"s":[84.38,84.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":197,"s":[82.67,82.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":198,"s":[80.84,80.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":199,"s":[78.89,78.89],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":200,"s":[76.81,76.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":201,"s":[74.59,74.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":202,"s":[72.24,72.24],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":203,"s":[69.75,69.75],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":204,"s":[67.11,67.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":205,"s":[64.32,64.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":206,"s":[61.38,61.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":207,"s":[58.29,58.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":208,"s":[55.03,55.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":209,"s":[51.61,51.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":210,"s":[48.01,48.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":211,"s":[44.25,44.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":212,"s":[40.3,40.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":213,"s":[36.18,36.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":214,"s":[31.87,31.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":215,"s":[27.37,27.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":216,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"el","hd":false,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[6,6]},"d":1},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":2,"ty":4,"nm":"","ln":"sVaXb7003aj6Tf6qVka9w","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":23,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":24,"s":[0.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":25,"s":[6.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":26,"s":[12.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":27,"s":[17.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":28,"s":[23.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":29,"s":[28.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":30,"s":[33.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":31,"s":[37.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":32,"s":[42.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":33,"s":[46.63],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[50.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[54.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[58.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[61.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[64.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[67.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[70.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[73.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[75.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[78.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[80.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[82.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[84.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[86.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[87.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[89.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[90.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[91.75],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[92.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[93.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[94.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[95.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[96.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[97.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[97.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[98.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[98.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[98.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[99.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[99.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[99.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[99.71],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[99.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[99.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[99.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":71,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":145,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":146,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":147,"s":[99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":148,"s":[99.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":149,"s":[99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":150,"s":[99.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":151,"s":[99.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":152,"s":[99.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":153,"s":[99.26],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":154,"s":[98.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":155,"s":[98.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":156,"s":[98.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":157,"s":[97.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":158,"s":[97.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":159,"s":[96.71],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":160,"s":[96.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":161,"s":[95.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":162,"s":[94.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":163,"s":[93.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":164,"s":[92.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":165,"s":[91.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":166,"s":[89.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":167,"s":[88.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":168,"s":[86.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":169,"s":[85.19],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":170,"s":[83.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":171,"s":[81.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":172,"s":[79.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":173,"s":[77.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":174,"s":[74.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":175,"s":[71.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":176,"s":[69.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":177,"s":[66.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":178,"s":[63.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":179,"s":[59.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":180,"s":[56.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":181,"s":[52.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":182,"s":[48.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":183,"s":[44.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":184,"s":[40.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":185,"s":[35.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":186,"s":[30.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":187,"s":[25.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":188,"s":[20.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":189,"s":[15.17],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":190,"s":[9.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":191,"s":[3.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":192,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":0,"k":[20,20]},"r":{"a":0,"k":0},"s":{"a":1,"k":[{"t":0,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":23,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":24,"s":[25.22,25.22],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":25,"s":[29.81,29.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":26,"s":[34.21,34.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":27,"s":[38.42,38.42],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":28,"s":[42.45,42.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":29,"s":[46.3,46.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":30,"s":[49.97,49.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":31,"s":[53.47,53.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":32,"s":[56.81,56.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":33,"s":[59.98,59.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[62.99,62.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[65.84,65.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[68.55,68.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[71.11,71.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[73.52,73.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[75.8,75.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[77.94,77.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[79.96,79.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[81.84,81.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[83.61,83.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[85.25,85.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[86.78,86.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[88.21,88.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[89.52,89.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[90.74,90.74],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":49,"s":[91.85,91.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":50,"s":[92.88,92.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":51,"s":[93.81,93.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":52,"s":[94.66,94.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":53,"s":[95.43,95.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":54,"s":[96.12,96.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":55,"s":[96.73,96.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":56,"s":[97.28,97.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":57,"s":[97.76,97.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":58,"s":[98.18,98.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":59,"s":[98.55,98.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":60,"s":[98.86,98.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":61,"s":[99.13,99.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":62,"s":[99.35,99.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":63,"s":[99.53,99.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":64,"s":[99.67,99.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":65,"s":[99.78,99.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":66,"s":[99.86,99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":67,"s":[99.92,99.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":68,"s":[99.96,99.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":69,"s":[99.98,99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":70,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":145,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":146,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":147,"s":[99.97,99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":148,"s":[99.94,99.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":149,"s":[99.9,99.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":150,"s":[99.83,99.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":151,"s":[99.73,99.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":152,"s":[99.6,99.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":153,"s":[99.44,99.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":154,"s":[99.24,99.24],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":155,"s":[99,99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":156,"s":[98.72,98.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":157,"s":[98.38,98.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":158,"s":[97.99,97.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":159,"s":[97.53,97.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":160,"s":[97.02,97.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":161,"s":[96.44,96.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":162,"s":[95.79,95.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":163,"s":[95.06,95.06],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":164,"s":[94.25,94.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":165,"s":[93.36,93.36],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":166,"s":[92.39,92.39],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":167,"s":[91.32,91.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":168,"s":[90.15,90.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":169,"s":[88.89,88.89],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":170,"s":[87.52,87.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":171,"s":[86.05,86.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":172,"s":[84.46,84.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":173,"s":[82.76,82.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":174,"s":[80.93,80.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":175,"s":[78.98,78.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":176,"s":[76.91,76.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":177,"s":[74.7,74.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":178,"s":[72.35,72.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":179,"s":[69.87,69.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":180,"s":[67.24,67.24],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":181,"s":[64.46,64.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":182,"s":[61.53,61.53],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":183,"s":[58.44,58.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":184,"s":[55.19,55.19],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":185,"s":[51.77,51.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":186,"s":[48.19,48.19],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":187,"s":[44.43,44.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":188,"s":[40.5,40.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":189,"s":[36.38,36.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":190,"s":[32.08,32.08],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":191,"s":[27.59,27.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":192,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":216,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"el","hd":false,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[6,6]},"d":1},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":3,"ty":4,"nm":"","ln":"kcUvBLTPIq11yfReLkV8s","sr":1,"ks":{"a":{"a":0,"k":[0,0]},"o":{"a":1,"k":[{"t":0,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":1,"s":[1.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":2,"s":[2.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":3,"s":[4.57],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":4,"s":[7.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":5,"s":[10.16],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":6,"s":[13.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":7,"s":[17.76],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":8,"s":[22.14],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":9,"s":[26.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":10,"s":[31.52],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":11,"s":[36.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":12,"s":[40.96],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":13,"s":[45.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":14,"s":[49.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":15,"s":[53.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":16,"s":[57.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":17,"s":[61.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":18,"s":[64.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":19,"s":[67.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":20,"s":[70.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":21,"s":[73.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":22,"s":[75.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":23,"s":[78.19],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":24,"s":[80.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":25,"s":[82.33],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":26,"s":[84.17],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":27,"s":[85.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":28,"s":[87.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":29,"s":[88.88],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":30,"s":[90.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":31,"s":[91.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":32,"s":[92.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":33,"s":[93.57],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[94.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[95.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[96.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[96.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[97.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[97.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[98.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[98.78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[99.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[99.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[99.63],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[99.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[99.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":121,"s":[100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":122,"s":[99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":123,"s":[99.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":124,"s":[99.93],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":125,"s":[99.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":126,"s":[99.77],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":127,"s":[99.65],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":128,"s":[99.48],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":129,"s":[99.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":130,"s":[99.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":131,"s":[98.69],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":132,"s":[98.31],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":133,"s":[97.86],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":134,"s":[97.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":135,"s":[96.74],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":136,"s":[96.06],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":137,"s":[95.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":138,"s":[94.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":139,"s":[93.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":140,"s":[92.39],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":141,"s":[91.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":142,"s":[89.91],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":143,"s":[88.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":144,"s":[86.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":145,"s":[85.27],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":146,"s":[83.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":147,"s":[81.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":148,"s":[79.38],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":149,"s":[77.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":150,"s":[74.7],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":151,"s":[72.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":152,"s":[69.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":153,"s":[66.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":154,"s":[63.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":155,"s":[59.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":156,"s":[56.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":157,"s":[52.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":158,"s":[48.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":159,"s":[44.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":160,"s":[40.46],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":161,"s":[35.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":162,"s":[31.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":163,"s":[26.15],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":164,"s":[20.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":165,"s":[15.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":166,"s":[9.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":167,"s":[3.74],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":168,"s":[0],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"p":{"a":0,"k":[11,20]},"r":{"a":0,"k":0},"s":{"a":1,"k":[{"t":0,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":1,"s":[25.79,25.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":2,"s":[26.92,26.92],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":3,"s":[28.43,28.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":4,"s":[30.33,30.33],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":5,"s":[32.62,32.62],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":6,"s":[35.3,35.3],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":7,"s":[38.32,38.32],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":8,"s":[41.6,41.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":9,"s":[45.08,45.08],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":10,"s":[48.64,48.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":11,"s":[52.22,52.22],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":12,"s":[55.72,55.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":13,"s":[59.11,59.11],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":14,"s":[62.34,62.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":15,"s":[65.4,65.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":16,"s":[68.28,68.28],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":17,"s":[70.97,70.97],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":18,"s":[73.49,73.49],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":19,"s":[75.83,75.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":20,"s":[78,78],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":21,"s":[80.03,80.03],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":22,"s":[81.9,81.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":23,"s":[83.64,83.64],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":24,"s":[85.25,85.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":25,"s":[86.75,86.75],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":26,"s":[88.13,88.13],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":27,"s":[89.4,89.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":28,"s":[90.58,90.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":29,"s":[91.66,91.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":30,"s":[92.66,92.66],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":31,"s":[93.58,93.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":32,"s":[94.41,94.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":33,"s":[95.18,95.18],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":34,"s":[95.87,95.87],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":35,"s":[96.5,96.5],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":36,"s":[97.07,97.07],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":37,"s":[97.58,97.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":38,"s":[98.04,98.04],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":39,"s":[98.44,98.44],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":40,"s":[98.79,98.79],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":41,"s":[99.09,99.09],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":42,"s":[99.34,99.34],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":43,"s":[99.55,99.55],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":44,"s":[99.72,99.72],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":45,"s":[99.85,99.85],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":46,"s":[99.94,99.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":47,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":48,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":121,"s":[100,100],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":122,"s":[99.99,99.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":123,"s":[99.98,99.98],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":124,"s":[99.95,99.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":125,"s":[99.9,99.9],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":126,"s":[99.83,99.83],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":127,"s":[99.73,99.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":128,"s":[99.61,99.61],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":129,"s":[99.45,99.45],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":130,"s":[99.25,99.25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":131,"s":[99.02,99.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":132,"s":[98.73,98.73],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":133,"s":[98.4,98.4],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":134,"s":[98.01,98.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":135,"s":[97.56,97.56],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":136,"s":[97.05,97.05],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":137,"s":[96.47,96.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":138,"s":[95.82,95.82],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":139,"s":[95.1,95.1],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":140,"s":[94.29,94.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":141,"s":[93.41,93.41],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":142,"s":[92.43,92.43],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":143,"s":[91.37,91.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":144,"s":[90.21,90.21],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":145,"s":[88.95,88.95],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":146,"s":[87.59,87.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":147,"s":[86.12,86.12],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":148,"s":[84.54,84.54],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":149,"s":[82.84,82.84],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":150,"s":[81.02,81.02],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":151,"s":[79.08,79.08],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":152,"s":[77.01,77.01],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":153,"s":[74.81,74.81],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":154,"s":[72.47,72.47],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":155,"s":[69.99,69.99],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":156,"s":[67.37,67.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":157,"s":[64.6,64.6],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":158,"s":[61.67,61.67],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":159,"s":[58.59,58.59],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":160,"s":[55.35,55.35],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":161,"s":[51.94,51.94],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":162,"s":[48.37,48.37],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":163,"s":[44.62,44.62],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":164,"s":[40.69,40.69],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":165,"s":[36.58,36.58],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":166,"s":[32.29,32.29],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":167,"s":[27.8,27.8],"i":{"x":0,"y":0},"o":{"x":1,"y":1}},{"t":168,"s":[25,25],"i":{"x":0,"y":0},"o":{"x":1,"y":1}}]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":216,"st":0,"bm":0,"shapes":[{"ty":"gr","hd":false,"bm":0,"it":[{"ty":"el","hd":false,"p":{"a":0,"k":[0,0]},"s":{"a":0,"k":[6,6]},"d":1},{"ty":"fl","hd":false,"bm":0,"c":{"a":0,"k":[1,1,1]},"r":1,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}],"np":0}]},{"ddd":0,"ind":4,"ty":4,"ln":"layer_4","sr":1,"ks":{"a":{"a":0,"k":[15,15]},"o":{"a":0,"k":100},"p":{"a":0,"k":[20,20]},"r":{"a":0,"k":0},"s":{"a":0,"k":[133.33,133.33]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}},"ao":0,"ip":0,"op":216,"st":0,"bm":0,"shapes":[{"ty":"gr","nm":"surface6","it":[{"ty":"gr","it":[{"ty":"sh","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[2.24,0],[2.31,-1.39],[1.27,-2.37],[-0.13,-2.7],[-1.3,-2.14],[0,0],[-0.25,-0.3],[-0.38,0.07],[0,0],[-2.12,-0.01],[-2.02,0.96],[-1.4,1.75],[-0.5,2.19],[0.5,2.19],[1.39,1.75],[2.02,0.97]],"o":[[-2.02,-0.98],[-2.7,0],[-2.31,1.38],[-1.27,2.37],[0.12,2.5],[0,0],[-0.14,0.36],[0.25,0.3],[0,0],[1.93,0.89],[2.24,0.01],[2.02,-0.96],[1.41,-1.75],[0.5,-2.18],[-0.49,-2.19],[-1.4,-1.76],[0,0]],"v":[[21.47,1.58],[15,0.1],[7.34,2.22],[1.87,7.96],[0.12,15.71],[2.29,22.79],[0.16,28.45],[0.34,29.52],[1.36,29.88],[8.79,28.54],[14.93,29.9],[21.41,28.45],[26.62,24.33],[29.52,18.35],[29.54,11.71],[26.66,5.72],[21.47,1.58]]}}},{"ty":"fl","c":{"a":0,"k":[0.12,0.65,0.46,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]},{"ty":"tr","nm":"Transform","a":{"a":0,"k":[0,0]},"o":{"a":0,"k":100},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"sa":{"a":0,"k":0}}]}]}],"meta":{"g":"https://jitter.video"},"nm":"무물보-질문하기","op":216,"v":"5.7.4","w":40}');
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/atom/CustomLottieIcon.tsx
var CustomLottieIcon = __webpack_require__(84655);
// EXTERNAL MODULE: ./src/components/atom/buttons/StickyButton.tsx
var StickyButton = __webpack_require__(91707);
// EXTERNAL MODULE: ./src/components/common/communication/qna/CategoryBottomSheet.tsx
var CategoryBottomSheet = __webpack_require__(80138);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ../../node_modules/lodash/isArray.js
var isArray = __webpack_require__(86152);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
;// CONCATENATED MODULE: ./src/components/molecules/InfoBox/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 0;\n  padding: 32px 24px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2px;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 0;\n  margin-bottom: 8px;\n  word-break: keep-all;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var INFO_BOX_VARIANT = {
    DEFAULT: "DEFAULT",
    WARNING: "WARNING",
    DANGER: "DANGER"
};
var INFO_BOX_MESSAGE_TYPE = {
    DEFAULT: "DEFAULT",
    DOT: "DOT"
};
var InfoBox = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? INFO_BOX_VARIANT.DEFAULT : _variant, title = param.title, message = param.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBoxContainer, {
        variant: variant,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBoxTitleWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBoxTitle, {
                    variant: variant,
                    children: title
                })
            }),
            isArray_default()(message) ? message.map(function(text, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBoxMessage, {
                    type: INFO_BOX_MESSAGE_TYPE.DOT,
                    children: text
                }, "infoBoxMessage-".concat(index));
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBoxMessage, {
                type: INFO_BOX_MESSAGE_TYPE.DEFAULT,
                children: message
            })
        ]
    });
};
/* harmony default export */ var molecules_InfoBox = (InfoBox);
var InfoBoxContainer = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-acb6de67-0"
})(_templateObject(), function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === INFO_BOX_VARIANT.WARNING ? theme.color.blue100 : variant === INFO_BOX_VARIANT.DANGER ? "".concat(theme.color.yellow100) : "".concat(theme.color.gray30);
});
var InfoBoxTitleWrapper = styled_components_browser_esm/* default.dt.withConfig */.ZP.dt.withConfig({
    componentId: "sc-acb6de67-1"
})(_templateObject1());
var InfoBoxTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-acb6de67-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, variant = param.variant;
    return "\n    ".concat(theme.typography.UI16SB, ";\n    color: ").concat(variant === INFO_BOX_VARIANT.WARNING ? theme.color.blue500 : variant === INFO_BOX_VARIANT.DANGER ? theme.color.yellow700 : theme.color.gray700, ";\n  ");
});
var InfoBoxMessage = styled_components_browser_esm/* default.dd.withConfig */.ZP.dd.withConfig({
    componentId: "sc-acb6de67-3"
})(_templateObject3(), function(param) {
    var theme = param.theme, type = param.type;
    return "\n    ".concat(theme.typography.UI12M, ";\n    color: ").concat(theme.color.gray400, ";\n    padding-left: ").concat(type === INFO_BOX_MESSAGE_TYPE.DOT ? "18px" : "0", ";\n\n    ").concat(type === INFO_BOX_MESSAGE_TYPE.DOT ? "\n      &::before {\n        content: '•';\n        position: absolute;\n        left: 6.5px;\n        color: ".concat(theme.color.gray300, ";\n      }") : "", "\n    ");
});

// EXTERNAL MODULE: ./src/components/molecules/StickyAppHeader/index.tsx + 4 modules
var StickyAppHeader = __webpack_require__(77314);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/atom/icon/AgreementCheck.tsx


var AgreementCheck = function(param) {
    var _color = param.color, color = _color === void 0 ? theme/* default.color.gray100 */.Z.color.gray100 : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_2549_19679",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_2549_19679)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.95838 12.2245L14.8089 5.37394C15.0305 5.15232 15.2932 5.0415 15.597 5.0415C15.9007 5.0415 16.1634 5.15232 16.385 5.37394C16.6066 5.59557 16.7174 5.85825 16.7174 6.162C16.7174 6.46574 16.6066 6.72842 16.385 6.95005L8.7419 14.5932C8.52027 14.8148 8.2591 14.9256 7.95838 14.9256C7.65766 14.9256 7.39648 14.8148 7.17486 14.5932L3.61507 11.0334C3.39345 10.8118 3.28416 10.5491 3.28717 10.2453C3.29018 9.94159 3.4025 9.6789 3.62413 9.45727C3.84575 9.23565 4.10844 9.12484 4.41219 9.12484C4.71593 9.12484 4.97861 9.23565 5.20023 9.45727L7.95838 12.2245Z",
                    fill: color
                })
            })
        ]
    });
};
/* harmony default export */ var icon_AgreementCheck = (AgreementCheck);

;// CONCATENATED MODULE: ./src/components/atom/icon/KeyboardArrowRight.tsx

var KeyboardArrowRight = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.5001 13.2292L10.7334 9.99583L7.5001 6.7625C7.1751 6.4375 7.1751 5.9125 7.5001 5.5875C7.8251 5.2625 8.3501 5.2625 8.6751 5.5875L12.5001 9.4125C12.8251 9.7375 12.8251 10.2625 12.5001 10.5875L8.6751 14.4125C8.3501 14.7375 7.8251 14.7375 7.5001 14.4125C7.18343 14.0875 7.1751 13.5542 7.5001 13.2292Z",
            fill: "#DFE1E2"
        })
    });
};
/* harmony default export */ var icon_KeyboardArrowRight = (KeyboardArrowRight);

// EXTERNAL MODULE: ./src/components/molecules/BottomSheet/index.tsx + 5 modules
var BottomSheet = __webpack_require__(39535);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Qna/QnaWriteMobileTemplate/PolicyAgreementBottomSheet.tsx



function PolicyAgreementBottomSheet_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  padding: 12px 24px 24px 24px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n"
    ]);
    PolicyAgreementBottomSheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PolicyAgreementBottomSheet_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n"
    ]);
    PolicyAgreementBottomSheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PolicyAgreementBottomSheet_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  align-self: stretch;\n  ",
        ";\n"
    ]);
    PolicyAgreementBottomSheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PolicyAgreementBottomSheet_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  align-self: stretch;\n  white-space: pre-wrap;\n  ",
        "\n"
    ]);
    PolicyAgreementBottomSheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 48px;\n  padding: 0px 16px;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 0px 10px 16px 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  align-self: stretch;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 8px 0px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1 0 0;\n\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 60px;\n  padding: 0px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n\n  border-radius: 12px;\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}





var PolicyAgreementBottomSheet = function(param) {
    var _viewModel = param.viewModel, isBottomSheetOpened = _viewModel.isBottomSheetOpened, checkAll = _viewModel.checkAll, isAllChecked = _viewModel.isAllChecked, policyList = _viewModel.policyList, checkPolicy = _viewModel.checkPolicy, isAllRequiredChecked = _viewModel.isAllRequiredChecked, isPolicyChecked = _viewModel.isPolicyChecked, closeBottomSheet = _viewModel.closeBottomSheet, agreeToPolicies = _viewModel.agreeToPolicies, openPolicyDetail = _viewModel.openPolicyDetail, afterSubmit = param.afterSubmit, isSubmitButtonDisabled = param.isSubmitButtonDisabled;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            agreeToPolicies()
                        ];
                    case 1:
                        _state.sent();
                        afterSubmit === null || afterSubmit === void 0 ? void 0 : afterSubmit();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* default */.ZP, {
        index: 10,
        isOpened: isBottomSheetOpened(),
        onClickOverlay: closeBottomSheet,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleAndDescription, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "상담을 위해 동의가 필요해요."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            children: "의료 상담 특성 상, 아래의 약관 동의가 필요해요.\n동의해주신만큼 도움되는 정보를 제공해드릴게요."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PolicyAgreementForm, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreeToAllButton, {
                            onClick: checkAll,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementCheckButton, {
                                    checked: isAllChecked()
                                }),
                                "전체 동의"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PolicyList, {
                            children: policyList.map(function(policy) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PolicyRow, {
                                    onClick: function() {
                                        return checkPolicy(policy);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckAndPolicyText, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementCheckButton, {
                                                    checked: isPolicyChecked(policy)
                                                }),
                                                "[".concat(policy.required ? "필수" : "선택", "] ").concat(policy.title)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return openPolicyDetail(policy);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_KeyboardArrowRight, {})
                                        })
                                    ]
                                }, "policy-".concat(policy.title));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    onClick: onSubmit,
                    activated: isAllRequiredChecked(),
                    disabled: !isAllRequiredChecked() || isSubmitButtonDisabled,
                    children: "확인"
                })
            ]
        })
    });
};
/* harmony default export */ var QnaWriteMobileTemplate_PolicyAgreementBottomSheet = (PolicyAgreementBottomSheet);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-0"
})(PolicyAgreementBottomSheet_templateObject());
var TitleAndDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-1"
})(PolicyAgreementBottomSheet_templateObject1());
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-2"
})(PolicyAgreementBottomSheet_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI20SB, ";\n    color: ").concat(theme.color.gray900, ";\n  ");
});
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-3"
})(PolicyAgreementBottomSheet_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});
var PolicyAgreementForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-4"
})(_templateObject4());
var AgreeToAllButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return "\n    border-radius: 8px;\n    border: 1px solid ".concat(theme.color.gray100, ";\n    \n    ").concat(theme.typography.UI16M, ";\n    color: ").concat(theme.color.gray600, ";   \n  ");
});
var PolicyList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-6"
})(_templateObject6());
var PolicyRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-7"
})(_templateObject7());
var CheckAndPolicyText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a70776f4-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16R, ";\n    color: ").concat(theme.color.gray900, ";\n  ");
});
var AgreementCheckButton = (0,styled_components_browser_esm/* default */.ZP)(icon_AgreementCheck).attrs(function(param) {
    var checked = param.checked, theme = param.theme;
    return {
        color: checked ? theme.color.primary600 : theme.color.gray100
    };
}).withConfig({
    componentId: "sc-a70776f4-9"
})(_templateObject9());
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a70776f4-10"
})(_templateObject10(), function(param) {
    var theme = param.theme, activated = param.activated;
    return "\n    background: ".concat(activated ? theme.color.primary600 : theme.color.gray100, ";\n    color: ").concat(theme.color.white, ";\n    ").concat(theme.typography.UI18SB, ";\n  ");
});

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(81541);
// EXTERNAL MODULE: ./src/components/atom/icon/AlertInformationCircle.tsx
var AlertInformationCircle = __webpack_require__(4794);
// EXTERNAL MODULE: ./src/components/atom/Form/InputLabel.tsx
var InputLabel = __webpack_require__(8628);
// EXTERNAL MODULE: ./src/components/atom/icon/Arrow/ArrowCaret.tsx
var ArrowCaret = __webpack_require__(78972);
;// CONCATENATED MODULE: ./src/components/molecules/Dropdown/index.tsx

function Dropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n\n  ",
        ";\n"
    ]);
    Dropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Dropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 18px 42px 18px 16px;\n  border: none;\n  background-color: transparent;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  ",
        ";\n"
    ]);
    Dropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Dropdown_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 16px;\n"
    ]);
    Dropdown_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Dropdown = function(param) {
    var id = param.id, label = param.label, labelSpacing = param.labelSpacing, className = param.className, placeholder = param.placeholder, isOpened = param.isOpened, onClickTrigger = param.onClickTrigger, _placeHolderColor = param.placeHolderColor, placeHolderColor = _placeHolderColor === void 0 ? "black" : _placeHolderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.ZP, {
                htmlFor: id,
                label: label,
                labelSpacing: labelSpacing,
                onClick: onClickTrigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownTrigger, {
                    type: "button",
                    onClick: onClickTrigger,
                    placeHolderColor: placeHolderColor,
                    children: [
                        placeholder,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownButtonChevron, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowCaret/* default */.Z, {
                                color: placeHolderColor,
                                direction: isOpened ? common/* DIRECTION.TOP */.JR.TOP : common/* DIRECTION.BOTTOM */.JR.BOTTOM
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var molecules_Dropdown = (Dropdown);
var DropdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4b25065-0"
})(Dropdown_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray200, ";\n    background: ").concat(theme.color.gray20, ";\n  ");
});
var DropdownTrigger = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-b4b25065-1"
})(Dropdown_templateObject1(), function(param) {
    var theme = param.theme, placeHolderColor = param.placeHolderColor;
    return "\n    ".concat(theme.typography.UI16M, ";\n    color: ").concat(placeHolderColor, ";\n    ");
});
var DropdownButtonChevron = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b4b25065-2"
})(Dropdown_templateObject2());

// EXTERNAL MODULE: ./src/components/atom/icon/checkBox/ReportCheckBox.tsx
var ReportCheckBox = __webpack_require__(12906);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Qna/QnaWriteMobileTemplate/QnaWriteAdditionalInfo.tsx

function QnaWriteAdditionalInfo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  & > button {\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 0;\n\n    & > p {\n      ",
        ";\n      color: ",
        ";\n    }\n  }\n\n  div:last-of-type {\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    QnaWriteAdditionalInfo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var QnaWriteAdditionalInfo = function(param) {
    var onClickCheckPregnant = param.onClickCheckPregnant, pregnant = param.pregnant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteAdditionalInfo_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            type: "button",
            onClick: onClickCheckPregnant,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportCheckBox/* default */.Z, {
                    isChecked: pregnant,
                    marginRight: 8
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "현재 임신 중입니다."
                })
            ]
        })
    });
};
/* harmony default export */ var QnaWriteMobileTemplate_QnaWriteAdditionalInfo = (QnaWriteAdditionalInfo);
var QnaWriteAdditionalInfo_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cb3a606-0"
})(QnaWriteAdditionalInfo_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI16M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI14M;
}, function(param) {
    var theme = param.theme;
    return theme.color.blue500;
});

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Qna/QnaWriteMobileTemplate/QnaWriteCategory.tsx


function QnaWriteCategory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    QnaWriteCategory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QnaWriteCategory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 12px;\n"
    ]);
    QnaWriteCategory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QnaWriteCategory_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 24px;\n  gap: 8px;\n"
    ]);
    QnaWriteCategory_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QnaWriteCategory_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n\n  ",
        ";\n"
    ]);
    QnaWriteCategory_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QnaWriteCategory_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  svg {\n    margin: 2px 6px 0 0;\n    min-width: 16px;\n  }\n\n  ",
        ";\n"
    ]);
    QnaWriteCategory_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var QnaWriteCategory = function(param) {
    var selectedTags = param.selectedTags, onChangeSelectedTags = param.onChangeSelectedTags, selectedCategoriesBottomSheetTabItem = param.selectedCategoriesBottomSheetTabItem, showCategoriesBottomSheet = param.showCategoriesBottomSheet, toggleCategoriesBottomSheet = param.toggleCategoriesBottomSheet, onClickCheckPregnant = param.onClickCheckPregnant, pregnant = param.pregnant, isAvailableAiAnswer = param.isAvailableAiAnswer;
    var onSelectTagItem = function(tag) {
        var tagIndex = selectedTags.findIndex(function(name) {
            return name === tag.name;
        });
        var list = (0,_to_consumable_array/* default */.Z)(selectedTags);
        if (tagIndex < 0) {
            list.push(tag.name);
        } else {
            list.splice(tagIndex, 1);
        }
        onChangeSelectedTags(list);
    };
    var isSelectedTag = function(tag) {
        return selectedTags.includes(tag.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuickAnswerCategoryWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_Dropdown, {
                id: "quickAnswerCategory",
                label: "카테고리",
                labelSpacing: "12px",
                placeholder: (selectedCategoriesBottomSheetTabItem === null || selectedCategoriesBottomSheetTabItem === void 0 ? void 0 : selectedCategoriesBottomSheetTabItem.title) || "증상•과목 선택",
                placeHolderColor: theme/* default.color.gray600 */.Z.color.gray600,
                isOpened: showCategoriesBottomSheet,
                onClickTrigger: function() {
                    return toggleCategoriesBottomSheet(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalInfoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteMobileTemplate_QnaWriteAdditionalInfo, {
                    onClickCheckPregnant: onClickCheckPregnant,
                    pregnant: pregnant
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickAnswerTagsWrapper, {
                children: selectedCategoriesBottomSheetTabItem === null || selectedCategoriesBottomSheetTabItem === void 0 ? void 0 : selectedCategoriesBottomSheetTabItem.tags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                        selected: isSelectedTag(tag),
                        onClick: function() {
                            return onSelectTagItem(tag);
                        },
                        children: tag.name
                    }, tag.name);
                })
            }),
            selectedCategoriesBottomSheetTabItem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationText, {
                marginTop: 24,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertInformationCircle/* default */.Z, {}),
                    "증상에 해당되는 태그를 모두 선택하시면 더욱 정확한 상담을 받을 수 있어요."
                ]
            }),
            isAvailableAiAnswer && (selectedCategoriesBottomSheetTabItem === null || selectedCategoriesBottomSheetTabItem === void 0 ? void 0 : selectedCategoriesBottomSheetTabItem.aiAnswerAvailable) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationText, {
                marginTop: 8,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertInformationCircle/* default */.Z, {}),
                    "해당 카테고리는 바로 AI 답변을 받을 수 있어요."
                ]
            })
        ]
    });
};
/* harmony default export */ var QnaWriteMobileTemplate_QnaWriteCategory = (QnaWriteCategory);
var QuickAnswerCategoryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c252306-0"
})(QnaWriteCategory_templateObject());
var AdditionalInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c252306-1"
})(QnaWriteCategory_templateObject1());
var QuickAnswerTagsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c252306-2"
})(QnaWriteCategory_templateObject2());
var Tag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-8c252306-3"
})(QnaWriteCategory_templateObject3(), function(param) {
    var theme = param.theme, selected = param.selected;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(selected ? theme.color.white : theme.color.gray600, ";\n    background: ").concat(selected ? theme.color.gray600 : theme.color.white, ";\n    border: 1px solid ").concat(selected ? theme.color.gray600 : theme.color.gray200, ";\n  ");
});
var InformationText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c252306-4"
})(QnaWriteCategory_templateObject4(), function(param) {
    var theme = param.theme, _marginTop = param.marginTop, marginTop = _marginTop === void 0 ? 12 : _marginTop;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.blue500, ";\n    margin-top: ").concat(marginTop, "px;\n  ");
});

// EXTERNAL MODULE: ./src/components/atom/Form/TextareaMobile.tsx
var TextareaMobile = __webpack_require__(11742);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Qna/QnaWriteMobileTemplate/QnaWriteContentTextarea.tsx

function QnaWriteContentTextarea_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 40px;\n"
    ]);
    QnaWriteContentTextarea_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QnaWriteContentTextarea_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 12px;\n"
    ]);
    QnaWriteContentTextarea_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var QnaWriteContentTextarea = function(param) {
    var question = param.question, onChangeQuestion = param.onChangeQuestion, placeholder = param.placeholder;
    var onChangeTextarea = function(event) {
        onChangeQuestion(event.target.value.replace(/^\s+/g, ""));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaContentWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteTextarea, {
            id: "quickAnswerQuestion",
            label: "질문",
            height: "150px",
            placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "예) 약을 처방 받았는데 술을 마셔도 될까요?",
            maxLength: 500,
            value: question,
            onChange: onChangeTextarea
        })
    });
};
/* harmony default export */ var QnaWriteMobileTemplate_QnaWriteContentTextarea = (QnaWriteContentTextarea);
var QnaContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ddcb99-0"
})(QnaWriteContentTextarea_templateObject());
var QnaWriteTextarea = (0,styled_components_browser_esm/* default */.ZP)(TextareaMobile/* default */.ZP).withConfig({
    componentId: "sc-2ddcb99-1"
})(QnaWriteContentTextarea_templateObject1());

// EXTERNAL MODULE: ./src/components/atom/buttons/DefaultButton.tsx
var DefaultButton = __webpack_require__(47641);
// EXTERNAL MODULE: ./src/components/atom/icon/Delete.tsx
var Delete = __webpack_require__(57471);
// EXTERNAL MODULE: ./src/components/atom/icon/Plus.tsx
var Plus = __webpack_require__(95699);
;// CONCATENATED MODULE: ./src/components/atom/icon/SecurityShieldProfile.tsx


var SecurityShieldProfileIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "24",
        viewBox: "0 0 16 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1967_27757)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1.65226 4.00703C1.4205 4.02764 1.16471 4.10559 0.956885 4.21894C0.41581 4.51404 0.0603155 5.05459 0.00657469 5.66396C-0.00211651 5.76252 -0.00222531 9.26977 0.00645309 9.51036C0.0293459 10.1447 0.0972947 10.7403 0.214875 11.337C0.636277 13.4757 1.64109 15.4336 3.1368 17.0304C3.18131 17.0779 3.23173 17.1331 3.24885 17.1531C3.28532 17.1957 3.60956 17.5071 3.76618 17.65C4.79143 18.5852 5.99132 19.3373 7.26824 19.8454C7.54733 19.9564 7.7351 19.9947 7.99998 19.9947C8.26949 19.9947 8.45214 19.9568 8.74558 19.8398C9.27419 19.629 9.83531 19.3524 10.336 19.0558C11.0255 18.6474 11.6984 18.1457 12.2854 17.6025C12.4592 17.4416 12.7117 17.198 12.748 17.1563C12.7669 17.1346 12.8174 17.0793 12.8603 17.0336C13.3666 16.4929 13.8048 15.9276 14.2037 15.3007C15.1098 13.8768 15.6955 12.2504 15.91 10.5632C15.951 10.2401 15.9831 9.84037 15.9915 9.5469C15.9938 9.46668 15.998 9.39955 16.001 9.39772C16.004 9.39589 16.0064 8.56352 16.0064 7.548C16.0064 6.3187 16.0042 5.70293 16 5.70556C15.996 5.708 15.9936 5.69655 15.9936 5.67553C15.9935 5.62605 15.9653 5.45476 15.9432 5.36956C15.7761 4.72702 15.273 4.22331 14.6324 4.05735C14.5444 4.03454 14.4333 4.01555 14.336 4.0067C14.2462 3.99853 1.74416 3.99885 1.65226 4.00703ZM1.77124 5.40824C1.67508 5.41948 1.60033 5.45729 1.52632 5.53213C1.47141 5.58765 1.43753 5.64487 1.41607 5.71836C1.40554 5.75441 1.40474 5.8553 1.40289 7.37276C1.40057 9.28898 1.40485 9.56769 1.44328 10.0032C1.60851 11.875 2.28915 13.6617 3.41326 15.1744C3.54563 15.3525 3.80759 15.68 3.81771 15.68C3.81943 15.68 3.85179 15.6532 3.88961 15.6206C4.19088 15.3606 4.55134 15.1089 4.90878 14.9089C5.03427 14.8387 5.3187 14.6966 5.43998 14.6434C6.07034 14.3673 6.69142 14.2016 7.34872 14.1344C7.75262 14.0931 8.24733 14.0931 8.65123 14.1344C9.65404 14.237 10.6262 14.5848 11.4816 15.1471C11.7038 15.2932 11.9117 15.4498 12.109 15.6196C12.1475 15.6528 12.1805 15.68 12.1822 15.68C12.1869 15.68 12.325 15.5129 12.4203 15.392C13.0588 14.5816 13.5778 13.6615 13.9422 12.6944C14.2946 11.759 14.505 10.7908 14.5724 9.79516C14.5946 9.46759 14.5951 9.4129 14.5952 7.58076L14.5952 5.76316L14.5804 5.71196C14.5587 5.63686 14.5274 5.58524 14.4678 5.5263C14.4123 5.47142 14.3552 5.43759 14.2816 5.41601C14.2451 5.40531 13.9388 5.40472 8.02878 5.40398C4.61086 5.40355 1.79497 5.40547 1.77124 5.40824ZM0.00313149 7.55516C0.00313149 8.57244 0.00387389 8.98764 0.00477629 8.47784C0.00567869 7.96803 0.00567869 7.13571 0.00477629 6.62824C0.00387389 6.12076 0.00313149 6.53788 0.00313149 7.55516ZM7.92318 6.8077C7.01265 6.8243 6.13036 7.20723 5.49115 7.86326C5.07665 8.28867 4.78529 8.79112 4.62138 9.36316C4.48231 9.84853 4.45398 10.4256 4.5444 10.9312C4.69621 11.7799 5.15301 12.5399 5.83358 13.0759C6.57256 13.658 7.51116 13.9154 8.45664 13.7954C8.95696 13.7318 9.4711 13.5439 9.89543 13.2695C10.7273 12.7316 11.2922 11.8794 11.4583 10.912C11.5261 10.5173 11.5243 10.0851 11.4532 9.69014C11.2857 8.75946 10.7432 7.93073 9.95518 7.40161C9.35532 6.99884 8.65566 6.79434 7.92318 6.8077ZM7.86238 8.21498C7.64576 8.23679 7.55687 8.25286 7.40293 8.29804C6.80844 8.47254 6.31129 8.91427 6.06733 9.48476C5.98155 9.68534 5.93202 9.87509 5.90612 10.1024C5.89587 10.1923 5.89594 10.4397 5.90624 10.5312C5.96341 11.0393 6.17711 11.4773 6.53861 11.8272C6.74624 12.0282 6.97745 12.1765 7.24478 12.2802C7.67285 12.4461 8.16736 12.4638 8.61243 12.3291C9.07671 12.1886 9.48799 11.8808 9.75797 11.472C10.0821 10.981 10.1848 10.3662 10.0382 9.79413C9.90904 9.29006 9.59447 8.84833 9.16002 8.56094C8.88483 8.3789 8.59305 8.27124 8.25381 8.22659C8.18544 8.21758 7.91587 8.20959 7.86238 8.21498ZM7.77278 15.511C7.55664 15.5242 7.43046 15.5368 7.26078 15.5622C6.91627 15.6138 6.57873 15.7034 6.23998 15.8334C5.9417 15.9478 5.60734 16.1168 5.34078 16.2878C5.17909 16.3915 4.92884 16.5767 4.83518 16.662L4.80318 16.6912L4.83518 16.7206C4.89819 16.7786 5.11408 16.9599 5.23728 17.0582C5.99194 17.6605 6.84965 18.1611 7.74539 18.522C7.88933 18.58 7.93239 18.5918 7.99998 18.5918C8.06756 18.5918 8.11063 18.58 8.25456 18.522C9.22007 18.1329 10.1314 17.5874 10.9376 16.9157C11.0866 16.7915 11.1936 16.6974 11.1936 16.6904C11.1936 16.6776 10.9667 16.4989 10.8192 16.3957C10.6172 16.2543 10.4556 16.1582 10.2176 16.0382C9.62259 15.7381 9.04889 15.577 8.37118 15.5196C8.29198 15.5129 7.84681 15.5065 7.77278 15.511Z",
                    fill: "#339AF0"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1967_27757",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(0 4)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var SecurityShieldProfile = (SecurityShieldProfileIcon);

// EXTERNAL MODULE: ./src/components/molecules/Loader/index.tsx + 1 modules
var Loader = __webpack_require__(6505);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Qna/QnaWriteMobileTemplate/QnaWriteImages.tsx

function QnaWriteImages_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 40px 0;\n"
    ]);
    QnaWriteImages_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    QnaWriteImages_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 8px;\n\n  ",
        ";\n"
    ]);
    QnaWriteImages_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding: 24px 0;\n  overflow: scroll;\n"
    ]);
    QnaWriteImages_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 72px;\n  height: 72px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    QnaWriteImages_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  ",
        ";\n"
    ]);
    QnaWriteImages_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  object-fit: cover;\n\n  ",
        ";\n"
    ]);
    QnaWriteImages_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  top: 4px;\n  right: 4px;\n  border-radius: 12px;\n  background: ",
        ";\n"
    ]);
    QnaWriteImages_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  border-radius: 8px;\n  background: ",
        ";\n"
    ]);
    QnaWriteImages_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n\n  ",
        ";\n\n  svg {\n    margin-right: 8px;\n  }\n"
    ]);
    QnaWriteImages_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function QnaWriteImages_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 26px;\n\n  ",
        ";\n"
    ]);
    QnaWriteImages_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}








var QnaWriteImages = function(param) {
    var isUploadingImage = param.isUploadingImage, questionImages = param.questionImages, imageInputRef = param.imageInputRef, onDeleteImage = param.onDeleteImage, onUploadImage = param.onUploadImage, onHandleChange = param.onHandleChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuickAnswerWriteImagesFieldWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesFieldLabel, {
                children: "사진 첨부 [선택]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagesFieldLabelDescription, {
                children: "증상과 관련된 사진을 최대 4장까지 첨부할 수 있어요."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImagesWrapper, {
                children: [
                    !!questionImages.length && questionImages.map(function(image, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionImageWrapper, {
                            isMargin: idx !== 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionImageDeleteButton, {
                                    type: "button",
                                    onClick: function() {
                                        return onDeleteImage(idx);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {
                                        size: 12
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionImage, {
                                    alt: "첨부이미지",
                                    width: "72",
                                    height: "72",
                                    src: image.blobUrl
                                })
                            ]
                        }, "question_image_".concat(idx));
                    }),
                    questionImages.length < 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyImageBox, {
                        type: "button",
                        onClick: function() {
                            return onUploadImage();
                        },
                        children: isUploadingImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {
                            color: theme/* default.color.gray600 */.Z.color.gray600,
                            width: 16,
                            height: 16
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: imageInputRef,
                        type: "file",
                        multiple: true,
                        onChange: onHandleChange,
                        accept: "image/*",
                        style: {
                            display: "none"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuestionImageInfomation, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageInfomationTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityShieldProfile, {}),
                            "안심하세요!"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageInfomationContent, {
                        children: "개인정보노출의 위험이 있는 사진은 작성자와 의료진에게만 보일 수 있도록 처리해드려요."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var QnaWriteMobileTemplate_QnaWriteImages = (QnaWriteImages);
var QuickAnswerWriteImagesFieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3900eac6-0"
})(QnaWriteImages_templateObject());
var ImagesFieldLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3900eac6-1"
})(QnaWriteImages_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.gray700, ";\n    ");
});
var ImagesFieldLabelDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3900eac6-2"
})(QnaWriteImages_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray400, ";\n    ");
});
var ImagesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3900eac6-3"
})(QnaWriteImages_templateObject3());
var EmptyImageBox = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-3900eac6-4"
})(QnaWriteImages_templateObject4(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.color.gray20, ";\n    border: 1px solid ").concat(theme.color.gray200, ";\n\n    &:active {\n    background: ").concat(theme.color.gray200, ";\n    }\n    ");
});
var QuestionImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3900eac6-5"
})(QnaWriteImages_templateObject5(), function(param) {
    var isMargin = param.isMargin;
    return isMargin && "margin-right: 16px";
});
var QuestionImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-3900eac6-6"
})(QnaWriteImages_templateObject6(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.color.gray200, ";\n  ");
});
var QuestionImageDeleteButton = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-3900eac6-7"
})(QnaWriteImages_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.color.dimmed80;
});
var QuestionImageInfomation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3900eac6-8"
})(QnaWriteImages_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.color.blue100;
});
var ImageInfomationTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3900eac6-9"
})(QnaWriteImages_templateObject9(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(theme.color.blue500, ";\n  ");
});
var ImageInfomationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3900eac6-10"
})(QnaWriteImages_templateObject10(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI14M, ";\n    color: ").concat(theme.color.gray500, ";\n  ");
});

// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84988);
// EXTERNAL MODULE: ../../node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(57506);
// EXTERNAL MODULE: ./src/components/atom/icon/Dot.tsx
var Dot = __webpack_require__(79409);
// EXTERNAL MODULE: ./src/hooks/useNeverSeeAgain.tsx
var useNeverSeeAgain = __webpack_require__(45889);
;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Qna/QnaWriteMobileTemplate/WriteOnBoarding/index.tsx

function WriteOnBoarding_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 17px;\n  text-align: center;\n  max-height: 95vh;\n  overflow-y: scroll;\n\n  * {\n    .swiper-pagination-horizontal {\n      position: initial;\n      margin-top: 12px;\n      display: flex;\n      justify-content: center;\n    }\n  }\n"
    ]);
    WriteOnBoarding_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  position: relative;\n  align-items: center;\n  margin: 0 20px;\n"
    ]);
    WriteOnBoarding_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 30px;\n  * {\n    &:not(:last-child) {\n      margin-right: 8px;\n    }\n  }\n"
    ]);
    WriteOnBoarding_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  ",
        ";\n"
    ]);
    WriteOnBoarding_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 40px 0 2px;\n\n  * {\n    .swiper {\n      padding: 0 20px;\n    }\n  }\n"
    ]);
    WriteOnBoarding_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 20px;\n"
    ]);
    WriteOnBoarding_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  margin-bottom: 6px;\n  white-space: break-spaces;\n"
    ]);
    WriteOnBoarding_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 12px;\n  ",
        ";\n"
    ]);
    WriteOnBoarding_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 37px;\n  max-width: 320px;\n  width: 100%;\n"
    ]);
    WriteOnBoarding_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function WriteOnBoarding_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"
    ]);
    WriteOnBoarding_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}











var onBoardingSteps = [
    {
        subTitle: "실시간 의료상담, 처음이시죠?",
        title: "쉽게 이용할 수 있도록\n설명해드릴게요!",
        guideImage: "/images/writeOnboarding/writeOnboarding_1_v3.png"
    },
    {
        subTitle: "사소한 질문도 괜찮아요",
        title: "실시간 상담은\n어떤 고민에도 귀기울여요",
        guideImage: "/images/writeOnboarding/writeOnboarding_2_v3.png"
    },
    {
        subTitle: "설명이 어렵다면 사진으로",
        title: "사진을 첨부하면 \n더 자세히 상담해드릴 수 있어요",
        guideImage: "/images/writeOnboarding/writeOnboarding_3_v3.png"
    },
    {
        subTitle: "안심하세요!",
        title: "의료진의 판단 하에\n개인정보 노출을 보호해드려요",
        guideImage: "/images/writeOnboarding/writeOnboarding_4_v3.png"
    }, 
];
var WriteOnBoarding = function(param) {
    var isVisible = param.isVisible, onCloseGuide = param.onCloseGuide;
    (0,useNeverSeeAgain/* default */.Z)();
    var ref = (0,react.useState)(0), currentStep = ref[0], setCurrentStep = ref[1];
    var onChangeStep = function(step) {
        setCurrentStep(step);
    };
    var swiperRef = (0,react.useRef)(null);
    var slideNext = function(changeStep) {
        var ref;
        onChangeStep(changeStep);
        (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideNext();
    };
    if (false) {}
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* default */.ZP, {
        isOpened: isVisible,
        index: 10,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WriteOnBoarding_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    children: currentStep !== onBoardingSteps.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skip, {
                        onClick: function() {
                            return onCloseGuide(true);
                        },
                        children: "건너뛰기"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperWrapper, {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        onSlideChange: function(e) {
                            return onChangeStep(e.activeIndex);
                        },
                        ref: swiperRef,
                        children: onBoardingSteps.map(function(step, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                        children: step.subTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteOnBoarding_Title, {
                                        children: step.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GuideImage, {
                                        src: step.guideImage
                                    })
                                ]
                            }, key);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bottom, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                            children: onBoardingSteps.map(function(_, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot/* default */.Z, {
                                    size: 8,
                                    color: currentStep === key ? theme/* default.color.primary500 */.Z.color.primary500 : theme/* default.color.gray100 */.Z.color.gray100
                                }, key);
                            })
                        }),
                        currentStep !== onBoardingSteps.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default.Button */.Z.Button, {
                                text: "다음",
                                onClick: function() {
                                    return slideNext(currentStep + 1);
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default.Button */.Z.Button, {
                                text: "이제 질문을 남겨보세요",
                                onClick: function() {
                                    return onCloseGuide();
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var QnaWriteMobileTemplate_WriteOnBoarding = (WriteOnBoarding);
var WriteOnBoarding_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1be0ccd-0"
})(WriteOnBoarding_templateObject());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1be0ccd-1"
})(WriteOnBoarding_templateObject1());
var Pagination = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1be0ccd-2"
})(WriteOnBoarding_templateObject2());
var Skip = (0,styled_components_browser_esm/* default */.ZP)(DefaultButton/* DefaultButtonStyled */.qY).withConfig({
    componentId: "sc-d1be0ccd-3"
})(WriteOnBoarding_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI15R, ";\n    color: ").concat(theme.color.gray300, "\n  ");
});
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1be0ccd-4"
})(WriteOnBoarding_templateObject4());
var SwiperWrapper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-d1be0ccd-5"
})(WriteOnBoarding_templateObject5());
var WriteOnBoarding_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1be0ccd-6"
})(WriteOnBoarding_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.typography.UI20SB;
});
var SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1be0ccd-7"
})(WriteOnBoarding_templateObject7(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI17SB, ";\n    color: ").concat(theme.color.primary700, "\n  ");
});
var GuideImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-d1be0ccd-8"
})(WriteOnBoarding_templateObject8());
var Bottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1be0ccd-9"
})(WriteOnBoarding_templateObject9());

;// CONCATENATED MODULE: ./src/components/templates/mobile/communication/Qna/QnaWriteMobileTemplate/index.tsx



function QnaWriteMobileTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-direction: column;\n"
    ]);
    QnaWriteMobileTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QnaWriteMobileTemplate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 40px;\n  width: 100%;\n"
    ]);
    QnaWriteMobileTemplate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QnaWriteMobileTemplate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 24px 0 4px;\n\n  ",
        ";\n"
    ]);
    QnaWriteMobileTemplate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QnaWriteMobileTemplate_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    QnaWriteMobileTemplate_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QnaWriteMobileTemplate_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 0 20px;\n"
    ]);
    QnaWriteMobileTemplate_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function QnaWriteMobileTemplate_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    QnaWriteMobileTemplate_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

















var infoBoxMessage = [
    "폭력적/공격적인 글, 서비스 목적과 맞지 않는 질문, 3회 이상 중복된(도배성) 질문은 예고 없이 삭제될 수 있어요.",
    "서비스 운영을 방해하는 행위가 반복적으로 발생할 경우, 회원 및 의료진 보호를 위해 서비스 이용이 한시적 또는 영구적으로 사전 안내 없이 제한될 수 있어요.",
    "실시간 의료상담 서비스에서\xa0받은 질문의 내용과 답변은 모두에게 공개되며, 서비스 홍보의 목적으로 활용될 수 있어요.",
    "답변은 의학적 판단이나 진료 행위로 해석될 수 없으며, 모든 약물 상호작용을 포함하지 않아요. 닥터나우와 답변 의료인은 이로 인해 발생하는 어떠한 책임도 지지 않아요.",
    "정확한 진단을 위해서는 닥터나우 앱 내에서 원격진료를 신청하거나, 병원을 방문해 주세요.",
    "실시간 의료상담에 등록하신 질문은 고객센터를 통한 삭제 요청이 없는 한 지속적으로 남게 돼요.",
    "의료진 판단 하에 비대면으로 답변이 어려운 질문은 환불이 진행될 수 있어요.", 
];
var QnaWriteMobileTemplate = function(_param) {
    var client = _param.client, _qnaWriteMobileViewModel = _param.qnaWriteMobileViewModel, _qnaWriteMobileViewModel = _qnaWriteMobileViewModel !== null ? _qnaWriteMobileViewModel : _throw(new TypeError("Cannot destructure undefined")), viewModel = (0,_extends/* default */.Z)({}, _param.qnaWriteMobileViewModel);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            client.isWebView && /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Header */.Z.Header, {
                useSafeArea: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyAppHeader/* default */.Z, {
                    title: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                            visible: true,
                            path: "".concat(common/* ROUTES.QNA.WRITE.path */.Z6.QNA.WRITE.path),
                            type: "qna"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuickAnswerWriteTemplateContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopTitleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLottieIcon/* default */.Z, {
                                        width: 40,
                                        height: 40,
                                        animationData: bubble_ask_namespaceObject
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopTitle, {
                                        children: "건강고민을 물어보세요"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopDescription, {
                                        children: "평균 5분 안에 답변 드려요"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuickAnswerWriteFormWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteMobileTemplate_QnaWriteContentTextarea, {
                                        question: viewModel.question,
                                        onChangeQuestion: viewModel.setQuestion,
                                        placeholder: (ref = viewModel.selectedCategoriesBottomSheetTabItem) === null || ref === void 0 ? void 0 : ref.contentPlaceholder
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteMobileTemplate_QnaWriteCategory, {
                                        selectedTags: viewModel.selectedTags,
                                        onChangeSelectedTags: viewModel.setSelectedTags,
                                        selectedCategoriesBottomSheetTabItem: viewModel.selectedCategoriesBottomSheetTabItem,
                                        showCategoriesBottomSheet: viewModel.showCategoriesBottomSheet,
                                        toggleCategoriesBottomSheet: viewModel.toggleCategoriesBottomSheet,
                                        onClickCheckPregnant: viewModel.onClickCheckPregnant,
                                        pregnant: viewModel.pregnant,
                                        isAvailableAiAnswer: client.isWebView
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteMobileTemplate_QnaWriteImages, {
                                        isUploadingImage: viewModel.isUploadingImage,
                                        questionImages: viewModel.questionImages,
                                        imageInputRef: viewModel.imageInputRef,
                                        onDeleteImage: viewModel.onDeleteImage,
                                        onUploadImage: viewModel.onUploadImage,
                                        onHandleChange: viewModel.onHandleChange
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickAnswerWriteInfoBoxWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_InfoBox, {
                                    variant: INFO_BOX_VARIANT.DEFAULT,
                                    title: "실시간 의료 상담은 이렇게 운영돼요.",
                                    message: infoBoxMessage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyButton/* default.Button */.Z.Button, {
                                    disabled: viewModel.isSubmitButtonDisabled,
                                    text: "물어보기",
                                    type: "submit",
                                    onClick: viewModel.checkEnableSubmit
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBottomSheet/* default */.Z, {
                                isVisible: viewModel.showCategoriesBottomSheet,
                                toggleBottomSheet: viewModel.toggleCategoriesBottomSheet,
                                onClickCategoryItem: viewModel.onClickCategoriesBottomSheetTabListItem,
                                categoryGroup: viewModel.categoryGroup,
                                selectedTab: viewModel.selectedTab,
                                onClickCategoriesBottomSheetTab: viewModel.onClickCategoriesBottomSheetTab,
                                getSelectedTabItemList: viewModel.getSelectedTabItemList
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteMobileTemplate_WriteOnBoarding, {
                                isVisible: !viewModel.neverSeeAgainGuide && !viewModel.neverSeeAgain.qnaWriteGuide,
                                onCloseGuide: viewModel.onCloseGuide
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaWriteMobileTemplate_PolicyAgreementBottomSheet, {
                                isSubmitButtonDisabled: viewModel.isSubmitButtonDisabled,
                                viewModel: viewModel.policyAgreementBottomSheetViewModel,
                                afterSubmit: viewModel.requestAiAnswer
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Qna_QnaWriteMobileTemplate = (QnaWriteMobileTemplate);
var QuickAnswerWriteTemplateContainer = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
    componentId: "sc-d2696935-0"
})(QnaWriteMobileTemplate_templateObject());
var TopTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2696935-1"
})(QnaWriteMobileTemplate_templateObject1());
var TopTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2696935-2"
})(QnaWriteMobileTemplate_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI22SB, ";\n    color: ").concat(theme.color.gray700, "\n    ");
});
var TopDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2696935-3"
})(QnaWriteMobileTemplate_templateObject3(), function(param) {
    var theme = param.theme;
    return "\n    ".concat(theme.typography.UI16M, ";\n    color: ").concat(theme.color.gray400, "\n    ");
});
var QuickAnswerWriteFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2696935-4"
})(QnaWriteMobileTemplate_templateObject4());
var QuickAnswerWriteInfoBoxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d2696935-5"
})(QnaWriteMobileTemplate_templateObject5());

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(22386);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(54073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/hooks/auth/useSetAuthOnScreenFocus.tsx
var useSetAuthOnScreenFocus = __webpack_require__(95392);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/qna.gql.impl.tsx
var qna_gql_impl = __webpack_require__(4365);
;// CONCATENATED MODULE: ./src/hooks/qna/mobile/Write/useSetApproveAgreements.ts

var useSetApproveAgreements = function() {
    var ref = (0,qna_gql_impl/* useSetApproveAgreementsMutation */.LN)(), setApproveAgreementMutate = ref.mutateAsync;
    return {
        setApproveAgreementMutate: setApproveAgreementMutate
    };
};
/* harmony default export */ var Write_useSetApproveAgreements = (useSetApproveAgreements);

// EXTERNAL MODULE: ./src/hooks/qna/qna.gql.impl.tsx
var qna_qna_gql_impl = __webpack_require__(71743);
// EXTERNAL MODULE: ./src/parsers/qna/index.ts
var qna = __webpack_require__(65083);
;// CONCATENATED MODULE: ./src/hooks/qna/useAgreementsForAskQuestionCategory.tsx


var useAgreementsForAskQuestionCategory = function() {
    var data = (0,qna_qna_gql_impl/* useGetAgreementsForQuestionCategoryQuery */.hC)({}, {
        select: qna/* parseAgreements */.IF
    }).data;
    return {
        data: data !== null && data !== void 0 ? data : []
    };
};
/* harmony default export */ var qna_useAgreementsForAskQuestionCategory = (useAgreementsForAskQuestionCategory);

;// CONCATENATED MODULE: ./src/hooks/qna/useGetCheckApprovedByCategory.tsx

var useGetCheckApprovedByCategory = function(param) {
    var category = param.category;
    var data = (0,qna_qna_gql_impl/* useGetCheckApprovedByCategoryQuery */.EU)({
        category: category
    }, {
        select: function(response) {
            return response.checkApproved;
        }
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ var qna_useGetCheckApprovedByCategory = (useGetCheckApprovedByCategory);

;// CONCATENATED MODULE: ./src/hooks/qna/useGetCheckApprovedByType.tsx

var useGetCheckApprovedByType = function(param) {
    var category = param.category, type = param.type;
    var data = (0,qna_qna_gql_impl/* useGetCheckApprovedByTypeQuery */.Sd)({
        request: {
            agreementCategory: category,
            agreementType: type
        }
    }, {
        select: function(response) {
            return response.checkApprovedByType;
        }
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ var qna_useGetCheckApprovedByType = (useGetCheckApprovedByType);

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
;// CONCATENATED MODULE: ./src/hooks/qna/mobile/Write/usePolicyAgreementBottomSheetViewModel.tsx










var usePolicyAgreementBottomSheetViewModel = function() {
    var ref = qna_useAgreementsForAskQuestionCategory(), _policyList = ref.data;
    var ref1 = qna_useGetCheckApprovedByCategory({
        category: gql_schema/* AgreementCategory.QnaAgreement */.Zw_.QnaAgreement
    }), hasAlreadyAgreedToAll = ref1.data;
    var ref2 = qna_useGetCheckApprovedByType({
        category: gql_schema/* AgreementCategory.QnaAgreement */.Zw_.QnaAgreement,
        type: gql_schema/* AgreementType.CollectHealthInformation */.qEJ.CollectHealthInformation
    }), hasAgreedToHealthInformation = ref2.data;
    var ref3 = qna_useGetCheckApprovedByType({
        category: gql_schema/* AgreementCategory.QnaAgreement */.Zw_.QnaAgreement,
        type: gql_schema/* AgreementType.LocationBasedServiceTermsAndConditions */.qEJ.LocationBasedServiceTermsAndConditions
    }), hasAgreedToLocation = ref3.data;
    var setApproveAgreementMutate = Write_useSetApproveAgreements().setApproveAgreementMutate;
    var ref4 = (0,react.useState)([]), checkedPolicyIdList = ref4[0], setCheckedPolicyIdList = ref4[1];
    var ref5 = (0,react.useState)(false), isPolicyAgreementBottomSheetOpened = ref5[0], setIsPolicyAgreementBottomSheetOpened = ref5[1];
    var policyList = (0,react.useMemo)(function() {
        return _policyList.filter(function(policy) {
            return !(policy.type === gql_schema/* AgreementType.LocationBasedServiceTermsAndConditions */.qEJ.LocationBasedServiceTermsAndConditions && (hasAgreedToLocation === null || hasAgreedToLocation === void 0 ? void 0 : hasAgreedToLocation.result));
        });
    }, [
        _policyList
    ]);
    var openPolicyAgreementBottomSheet = function() {
        setIsPolicyAgreementBottomSheetOpened(true);
    };
    var closePolicyAgreementBottomSheet = function() {
        setIsPolicyAgreementBottomSheetOpened(false);
    };
    var checkedPolicyList = (0,react.useMemo)(function() {
        return policyList.filter(function(policy) {
            return checkedPolicyIdList.includes(policy.id);
        });
    }, [
        checkedPolicyIdList,
        policyList
    ]);
    var checkAll = function() {
        if (checkedPolicyIdList.length === policyList.length) {
            setCheckedPolicyIdList([]);
        } else {
            setCheckedPolicyIdList(policyList.map(function(policy) {
                return policy.id;
            }));
        }
    };
    var checkPolicy = function(policy) {
        if (checkedPolicyIdList.includes(policy.id)) {
            setCheckedPolicyIdList(function(_prev) {
                return _prev.filter(function(id) {
                    return id !== policy.id;
                });
            });
        } else {
            setCheckedPolicyIdList(function(_prev) {
                return (0,_to_consumable_array/* default */.Z)(_prev).concat([
                    policy.id
                ]);
            });
        }
    };
    var isAllChecked = function() {
        if (policyList.length === 0) {
            return false;
        }
        return Boolean(checkedPolicyIdList.length === policyList.length);
    };
    var isAllRequiredChecked = function() {
        if (policyList.length === 0) {
            return false;
        }
        var requiredList = policyList.filter(function(policy) {
            return policy.required;
        });
        return requiredList.length === 0 || requiredList.every(function(policy) {
            return checkedPolicyIdList.includes(policy.id);
        });
    };
    var isPolicyChecked = function(policy) {
        return checkedPolicyIdList.includes(policy.id);
    };
    var agreeToPolicies = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setApproveAgreementMutate({
                                request: {
                                    approvedAgreementIds: (0,_to_consumable_array/* default */.Z)(checkedPolicyIdList.map(function(id) {
                                        return Number(id);
                                    })),
                                    disapprovedAgreementIds: []
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function agreeToPolicies() {
            return _ref.apply(this, arguments);
        };
    }();
    var hasAgreedToMinimum = Boolean((hasAgreedToLocation === null || hasAgreedToLocation === void 0 ? void 0 : hasAgreedToLocation.result) && (hasAgreedToHealthInformation === null || hasAgreedToHealthInformation === void 0 ? void 0 : hasAgreedToHealthInformation.result));
    var openPolicyDetail = function(policy) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */.nn.OPEN_EXTERNAL_BROWSER, {
                url: policy.url
            });
        }
        window.open(policy.url, "_blank");
    };
    return {
        policyList: policyList,
        checkedPolicyList: checkedPolicyList,
        checkPolicy: checkPolicy,
        checkAll: checkAll,
        isAllChecked: isAllChecked,
        isAllRequiredChecked: isAllRequiredChecked,
        isPolicyChecked: isPolicyChecked,
        hasAlreadyAgreedToAll: function() {
            return Boolean(hasAlreadyAgreedToAll);
        },
        hasAgreedToMinimum: function() {
            return hasAgreedToMinimum;
        },
        hasAgreedToLocation: function() {
            return Boolean(hasAgreedToLocation === null || hasAgreedToLocation === void 0 ? void 0 : hasAgreedToLocation.result);
        },
        agreeToPolicies: agreeToPolicies,
        isBottomSheetOpened: function() {
            return Boolean(isPolicyAgreementBottomSheetOpened);
        },
        openBottomSheet: openPolicyAgreementBottomSheet,
        closeBottomSheet: closePolicyAgreementBottomSheet,
        openPolicyDetail: openPolicyDetail
    };
};
/* harmony default export */ var Write_usePolicyAgreementBottomSheetViewModel = (usePolicyAgreementBottomSheetViewModel);

// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useGetCommunityUser.tsx
var useGetCommunityUser = __webpack_require__(38102);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(8391);
;// CONCATENATED MODULE: ./src/api/image.tsx




var uploadImage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
        var ref, _attachmentUploadPreSignedUrl, originalPath, originalPreSignedUrl, thumbnailPath, thumbnailPreSignedUrl, ref1, originStatus, ref2, thumbnailStatus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        qna_qna_gql_impl/* useAttachmentUploadPreSignedUrlQuery.fetcher */.IC.fetcher({
                            fileExtension: params.fileExtension
                        })()
                    ];
                case 1:
                    ref = _state.sent(), _attachmentUploadPreSignedUrl = ref.attachmentUploadPreSignedUrl, originalPath = _attachmentUploadPreSignedUrl.originalPath, originalPreSignedUrl = _attachmentUploadPreSignedUrl.originalPreSignedUrl, thumbnailPath = _attachmentUploadPreSignedUrl.thumbnailPath, thumbnailPreSignedUrl = _attachmentUploadPreSignedUrl.thumbnailPreSignedUrl;
                    return [
                        4,
                        (0,fetcher/* preSignedUrlFetch */.Xy)().put("".concat(originalPreSignedUrl), params.imageFile.origin)
                    ];
                case 2:
                    ref1 = _state.sent(), originStatus = ref1.status;
                    return [
                        4,
                        (0,fetcher/* preSignedUrlFetch */.Xy)().put("".concat(thumbnailPreSignedUrl), params.imageFile.thumbnail)
                    ];
                case 3:
                    ref2 = _state.sent(), thumbnailStatus = ref2.status;
                    return [
                        2,
                        {
                            success: originStatus === 200 && thumbnailStatus === 200,
                            imagePath: {
                                originalPath: originalPath,
                                thumbnailPath: thumbnailPath
                            }
                        }
                    ];
            }
        });
    });
    return function uploadImage(params) {
        return _ref.apply(this, arguments);
    };
}();
var image_image = {
    uploadImage: uploadImage
};
/* harmony default export */ var api_image = (image_image);

;// CONCATENATED MODULE: ./src/hooks/useUploadImage.tsx


var useUploadImage = function() {
    return (0,useMutation/* useMutation */.D)(function(params) {
        return api_image.uploadImage(params);
    });
};
/* harmony default export */ var hooks_useUploadImage = (useUploadImage);

// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/recoil/atoms/common/neverSeeAgain.ts
var common_neverSeeAgain = __webpack_require__(92080);
// EXTERNAL MODULE: ./src/recoil/atoms/common/user.ts
var common_user = __webpack_require__(3818);
// EXTERNAL MODULE: ./src/recoil/atoms/qna/index.ts
var atoms_qna = __webpack_require__(96469);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/types/qna.ts
var types_qna = __webpack_require__(18457);
// EXTERNAL MODULE: ./src/utils/error.ts
var utils_error = __webpack_require__(88295);
// EXTERNAL MODULE: ./src/utils/image.ts
var utils_image = __webpack_require__(60288);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/Home/useGetMyUncheckedAiAnswer.ts
var useGetMyUncheckedAiAnswer = __webpack_require__(47863);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/Write/useQnaWriteBottomSheetGroup.ts
var useQnaWriteBottomSheetGroup = __webpack_require__(85978);
// EXTERNAL MODULE: ./src/hooks/qna/useGetQnaCategoryGroup.ts
var useGetQnaCategoryGroup = __webpack_require__(62139);
;// CONCATENATED MODULE: ./src/hooks/qna/useQnaWriteMobileViewModel.ts


































var useQnaWriteMobileViewModel = function() {
    (0,useSetAuthOnScreenFocus/* default */.Z)();
    (0,useNeverSeeAgain/* default */.Z)();
    var setShowAuthModal = (0,useAuthModal/* default */.Z)().setShowAuthModal;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var ref = (0,useCustomRouter/* default */.Z)(), pageName = ref.pageName, moveToPage = ref.moveToPage;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var setRealTimeAnswerState = (0,es.useSetRecoilState)(atoms_qna/* realTimeAnswerState */.N);
    var qnaWriteBottomSheetGroup = (0,useQnaWriteBottomSheetGroup/* default */.Z)();
    var unCheckedAiAnswer = (0,useGetMyUncheckedAiAnswer/* default */.Z)();
    var policyAgreementBottomSheetViewModel = Write_usePolicyAgreementBottomSheetViewModel();
    var ref2 = (0,react.useState)(""), question = ref2[0], setQuestion = ref2[1];
    var ref3 = (0,react.useState)(false), isSubmitLoading = ref3[0], setIsSubmitLoading = ref3[1];
    var ref4 = (0,react.useState)(false), pregnant = ref4[0], setPregnant = ref4[1];
    var ref5 = (0,react.useState)([]), selectedTags = ref5[0], setSelectedTags = ref5[1];
    var ref6 = (0,react.useState)([]), attachments = ref6[0], setAttachments = ref6[1];
    var ref7 = (0,react.useState)(false), showCategoriesBottomSheet = ref7[0], setShowCategoriesBottomSheet = ref7[1];
    var ref8 = (0,react.useState)(false), isUploadingImage = ref8[0], setIsUploadingImage = ref8[1];
    var userProfile = (0,useGetCommunityUser/* default */.Z)().userProfile;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,es.useRecoilState)(common_neverSeeAgain/* neverSeeAgainState */.b), 2), neverSeeAgain = ref9[0], setNeverSeeAgain = ref9[1];
    var ref10 = (0,react.useState)(neverSeeAgain.qnaWriteGuide), neverSeeAgainGuide = ref10[0], setNeverSeeAgainGuide = ref10[1];
    var user = (0,es.useRecoilValue)(common_user/* userState */.KL);
    var ref11 = (0,react.useState)(types_qna/* QnaCategoryType.TREATMENT */.Q0.TREATMENT), selectedTab = ref11[0], setSelectedTab = ref11[1];
    var imageInputRef = (0,react.useRef)(null);
    var ref12 = (0,react.useState)([]), questionImages = ref12[0], setQuestionImages = ref12[1];
    var categoryGroup = (0,useGetQnaCategoryGroup/* default */.Z)().categoryGroup;
    // 이미지 등록
    var ref13 = hooks_useUploadImage(), uploadImageMutateAsync = ref13.mutateAsync;
    // 질문 작성
    var ref14 = (0,qna_gql_impl/* useAddQuestionWithAiAnswerMutation */.u1)(), addQuestionWithAiAnswerMutate = ref14.mutate;
    var ref15 = (0,react.useState)(), selectedCategoriesBottomSheetTabItem = ref15[0], setSelectedCategoriesBottomSheetTabItem = ref15[1];
    var isSubmitButtonDisabled = (0,react.useMemo)(function() {
        return isSubmitLoading || isUploadingImage || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.isBanned) || qnaWriteBottomSheetGroup.isGeolocationLoading;
    }, [
        isSubmitLoading,
        isUploadingImage,
        userProfile === null || userProfile === void 0 ? void 0 : userProfile.isBanned,
        qnaWriteBottomSheetGroup.isGeolocationLoading
    ]);
    var onSubmitSuccess = function(response) {
        if (!(0,RNPlugins/* isWebView */.vp)()) {
            setRealTimeAnswerState(true);
        }
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "quick_answer_write_submit_click",
                pageName: pageName
            }
        });
        var _addQuestionV2 = response.addQuestionV2, aiAnswerAvailable = _addQuestionV2.aiAnswerAvailable, questionPid = _addQuestionV2.questionPid;
        if (aiAnswerAvailable) {
            moveToPage({
                webLink: "".concat(common/* ROUTES.QNA.AI.path */.Z6.QNA.AI.path, "/").concat(questionPid),
                mobileScreenName: common/* ROUTES.QNA.AI.appScreenName */.Z6.QNA.AI.appScreenName,
                params: {
                    questionPid: questionPid
                },
                type: RNPlugins/* NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */.nn.REPLACE_TO_PAGE
            });
            return;
        }
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.AITITLE.path */.Z6.QNA.AITITLE.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.AITITLE.appScreenName */.Z6.QNA.AITITLE.appScreenName,
            params: {
                questionPid: questionPid
            },
            type: RNPlugins/* NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */.nn.REPLACE_TO_PAGE
        });
    };
    var onSubmitError = function(error) {
        return showToast({
            message: (0,utils_error/* getBffErrorMessage */.p)(error)
        });
    };
    var onClickCheckPregnant = function() {
        setPregnant(function(prev) {
            return !prev;
        });
    };
    // 카테고리 Bottom Sheet Show/Hide Toggle
    var toggleCategoriesBottomSheet = function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        setShowCategoriesBottomSheet(value);
    };
    // 카테고리 Bottom Sheet Tab Click
    var onClickCategoriesBottomSheetTab = function(tab) {
        setSelectedTab(tab.value);
    };
    var getSelectedTabItemList = function() {
        if (!categoryGroup) return [];
        return categoryGroup.tabsList.filter(function(tab) {
            return tab.key === selectedTab;
        })[0].categories;
    };
    // Bottom Sheet Tab List Item Click Handler
    var onClickCategoriesBottomSheetTabListItem = function(item) {
        setSelectedCategoriesBottomSheetTabItem(item);
        toggleCategoriesBottomSheet(false);
    };
    var onCloseGuide = function(skip) {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: skip ? "qna_onboarding_skip_click" : "qna_onboarding_complete_click",
                pageName: pageName
            }
        });
        if (!(0,RNPlugins/* isWebView */.vp)()) {
            setNeverSeeAgain((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, neverSeeAgain), {
                qnaWriteGuide: true
            }));
        } else {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.SET_NEVER_SEE_AGAIN */.nn.SET_NEVER_SEE_AGAIN, {
                state: "qnaWriteGuide"
            });
        }
        setNeverSeeAgainGuide(true);
    };
    var onDeleteImage = function(idx) {
        setQuestionImages(function() {
            var images = questionImages.slice();
            images.splice(idx, 1);
            return images;
        });
        setAttachments(function() {
            var newAttachments = attachments.slice();
            newAttachments.splice(idx, 1);
            return newAttachments;
        });
    };
    var onUploadImage = function() {
        if (!token) {
            // 로그인 정보가 없는 경우
            setShowAuthModal(true);
        } else {
            var ref;
            (ref = imageInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
        }
    };
    var uploadImageToS3 = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(files) {
            var uploadedImages, uploadedAttachments, uploadFiles;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        uploadedImages = [];
                        uploadedAttachments = [];
                        uploadFiles = files.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(file) {
                                var ref, success, imagePath, image;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                uploadImageMutateAsync({
                                                    fileExtension: file.origin.type.split("/")[1],
                                                    imageFile: {
                                                        origin: file.origin,
                                                        thumbnail: file.thumbnail
                                                    }
                                                })
                                            ];
                                        case 1:
                                            ref = _state.sent(), success = ref.success, imagePath = ref.imagePath;
                                            if (!success) return [
                                                3,
                                                3
                                            ];
                                            return [
                                                4,
                                                (0,utils_image/* setImageUrl */.B4)(file.thumbnail)
                                            ];
                                        case 2:
                                            image = _state.sent();
                                            uploadedImages.push(image);
                                            uploadedAttachments.push({
                                                originalPath: imagePath.originalPath,
                                                thumbnailPath: imagePath.thumbnailPath
                                            });
                                            _state.label = 3;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(file) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            4,
                            Promise.all(uploadFiles)
                        ];
                    case 1:
                        _state.sent();
                        setQuestionImages((0,_to_consumable_array/* default */.Z)(questionImages).concat((0,_to_consumable_array/* default */.Z)(uploadedImages)));
                        setAttachments((0,_to_consumable_array/* default */.Z)(attachments).concat((0,_to_consumable_array/* default */.Z)(uploadedAttachments)));
                        setIsUploadingImage(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadImageToS3(files) {
            return _ref.apply(this, arguments);
        };
    }();
    var onHandleChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var attachedFile, enabledImageCount, filteredImages, convertedImages, images;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!e.target.files) return [
                            3,
                            4
                        ];
                        attachedFile = Array.from(e.target.files);
                        enabledImageCount = 4 - questionImages.length;
                        if (!(enabledImageCount > 0)) return [
                            3,
                            4
                        ];
                        setIsUploadingImage(true);
                        filteredImages = attachedFile.slice(0, enabledImageCount).filter(function(image) {
                            var isImage = image.type.includes("image");
                            if (!isImage) {
                                return showModal({
                                    type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                                    props: {
                                        title: "사진 파일을 올려주세요",
                                        message: "jpg, jpeg, png 확장자만 올릴 수 있어요.",
                                        buttons: [
                                            {
                                                type: modal/* MODAL_BUTTON_TYPE.BOLD */.J.BOLD,
                                                label: "확인",
                                                onClick: function() {
                                                    closeModal();
                                                }
                                            }, 
                                        ]
                                    }
                                });
                            }
                            return isImage;
                        });
                        return [
                            4,
                            Promise.all(filteredImages.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(image) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!image.type.includes("heic")) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0,utils_image/* convertHeic */.RW)(image)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    image
                                                ];
                                        }
                                    });
                                });
                                return function(image) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        convertedImages = _state.sent();
                        return [
                            4,
                            Promise.all(convertedImages.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(image) {
                                    var _tmp;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _tmp = {};
                                                return [
                                                    4,
                                                    (0,utils_image/* onCompressImage */.VM)(image, {
                                                        maxSizeMB: 5
                                                    })
                                                ];
                                            case 1:
                                                _tmp.origin = _state.sent();
                                                return [
                                                    4,
                                                    (0,utils_image/* onCompressImage */.VM)(image, {
                                                        maxSizeMB: 0.2,
                                                        maxWidthOrHeight: 300
                                                    })
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    (_tmp.thumbnail = _state.sent(), _tmp)
                                                ];
                                        }
                                    });
                                });
                                return function(image) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        images = _state.sent();
                        return [
                            4,
                            uploadImageToS3(images)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onHandleChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkEnableSubmit = function(e) {
        e.preventDefault();
        if (!token) {
            setShowAuthModal(true);
            return;
        }
        if ((0,RNPlugins/* isWebView */.vp)()) {
            if (!user.isCertified) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_CERTIFICATION_SCREEN */.nn.MOVE_CERTIFICATION_SCREEN, {
                    params: {
                        base: "qna"
                    }
                });
                return false;
            }
        }
        if (question.length <= 4) {
            showToast({
                message: "질문을 최소 5자 이상 입력해주세요."
            });
            return false;
        }
        if (!selectedCategoriesBottomSheetTabItem) {
            showToast({
                message: "카테고리를 선택해주세요."
            });
            return false;
        }
        if (policyAgreementBottomSheetViewModel.hasAlreadyAgreedToAll() || policyAgreementBottomSheetViewModel.hasAgreedToMinimum()) {
            requestAiAnswer();
        } else {
            policyAgreementBottomSheetViewModel.openBottomSheet();
        }
    };
    var requestExpertAnswer = debounce_default()(function() {
        var _activeBottomSheetType;
        (0,logger/* communityLogger */.S4)({
            eventName: "click_expert_answer_bottom_sheet",
            pageName: pageName,
            payload: {
                type: (_activeBottomSheetType = qnaWriteBottomSheetGroup.activeBottomSheetType) !== null && _activeBottomSheetType !== void 0 ? _activeBottomSheetType : ""
            }
        });
        if (qnaWriteBottomSheetGroup.isApprovedByLocationCategory || qnaWriteBottomSheetGroup.isCheckedAgreement) {
            onClickApproveGeolocation(false);
        } else {
            onSubmit({
                isAiAnswer: false
            });
        }
    }, 1000, {
        leading: true,
        trailing: false
    });
    var requestAiAnswer = function() {
        var _activeBottomSheetType;
        (0,logger/* communityLogger */.S4)({
            eventName: "click_ai_answer_bottom_sheet",
            pageName: pageName,
            payload: {
                type: (_activeBottomSheetType = qnaWriteBottomSheetGroup.activeBottomSheetType) !== null && _activeBottomSheetType !== void 0 ? _activeBottomSheetType : ""
            }
        });
        onSubmit({
            isAiAnswer: true
        });
    };
    // 질문 submit
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var coordinate, isAiAnswer;
            return (0,tslib_es6.__generator)(this, function(_state) {
                coordinate = param.coordinate, isAiAnswer = param.isAiAnswer;
                if (!selectedCategoriesBottomSheetTabItem) return [
                    2
                ];
                setIsSubmitLoading(true);
                addQuestionWithAiAnswerMutate({
                    request: {
                        content: question,
                        pregnant: pregnant,
                        categoryId: selectedCategoriesBottomSheetTabItem.value,
                        tagNames: selectedTags,
                        aiAnswerAvailable: isAiAnswer,
                        location: coordinate !== null && coordinate !== void 0 ? coordinate : null,
                        attachments: attachments
                    }
                }, {
                    onSuccess: onSubmitSuccess,
                    onError: onSubmitError
                });
                return [
                    2
                ];
            });
        });
        return function onSubmit(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickApproveGeolocation = function() {
        var isAiAnswer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var _activeBottomSheetType;
        (0,logger/* communityLogger */.S4)({
            eventName: "click_near_doctor_alert_approve",
            pageName: pageName,
            payload: {
                type: (_activeBottomSheetType = qnaWriteBottomSheetGroup.activeBottomSheetType) !== null && _activeBottomSheetType !== void 0 ? _activeBottomSheetType : ""
            }
        });
        qnaWriteBottomSheetGroup.requestGeolocation({
            onSuccess: function(coordinate) {
                qnaWriteBottomSheetGroup.setApproveAgreement();
                onSubmit({
                    coordinate: coordinate,
                    isAiAnswer: isAiAnswer
                });
            }
        });
    };
    var onClickNearDoctorAlertSkip = function() {
        var _activeBottomSheetType;
        (0,logger/* communityLogger */.S4)({
            eventName: "click_near_doctor_alert_skip",
            pageName: pageName,
            payload: {
                type: (_activeBottomSheetType = qnaWriteBottomSheetGroup.activeBottomSheetType) !== null && _activeBottomSheetType !== void 0 ? _activeBottomSheetType : ""
            }
        });
        qnaWriteBottomSheetGroup.onChangeBottomSheetType();
        onSubmit({
            isAiAnswer: selectedCategoriesBottomSheetTabItem === null || selectedCategoriesBottomSheetTabItem === void 0 ? void 0 : selectedCategoriesBottomSheetTabItem.aiAnswerAvailable
        });
    };
    var onClickAiAnswerDetail = function(questionPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.AI.path */.Z6.QNA.AI.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.AI.appScreenName */.Z6.QNA.AI.appScreenName,
            params: {
                questionPid: questionPid
            }
        });
    };
    (0,react.useEffect)(function() {
        setSelectedTags([]);
    }, [
        selectedCategoriesBottomSheetTabItem
    ]);
    (0,react.useEffect)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            if (question || selectedCategoriesBottomSheetTabItem || attachments.length) {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.SET_PREVENT_BACK */.nn.SET_PREVENT_BACK, {
                    preventBack: true
                });
            } else {
                (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.SET_PREVENT_BACK */.nn.SET_PREVENT_BACK, {
                    preventBack: false
                });
            }
        }
    }, [
        question,
        selectedCategoriesBottomSheetTabItem,
        attachments
    ]);
    (0,react.useEffect)(function() {
        if (userProfile === null || userProfile === void 0 ? void 0 : userProfile.isBanned) {
            showModal({
                type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                props: {
                    title: "서비스 이용 제한",
                    message: "실시간 상담 운영 정책 위반으로 활동이 제한 되었습니다.",
                    buttons: [
                        {
                            type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                            label: "확인",
                            onClick: function() {
                                closeModal();
                                (0,RNPlugins/* historyBack */.$i)();
                            }
                        }, 
                    ]
                }
            });
        }
    }, [
        userProfile
    ]);
    (0,react.useEffect)(function() {
        if (unCheckedAiAnswer && (unCheckedAiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationRequested */.cx.GenerationRequested || unCheckedAiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.Generating */.cx.Generating || unCheckedAiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationComplete */.cx.GenerationComplete || unCheckedAiAnswer.aiAnswerStatus === gql_schema/* AiAnswerStatus.GenerationFailed */.cx.GenerationFailed) && unCheckedAiAnswer.status !== gql_schema/* QuestionStatus.PaymentFailed */.xVd.PaymentFailed) showModal({
            type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
            props: {
                title: "기존 답변을 먼저 확인해 주세요",
                message: "고민이 해결됐는지 의료진 상담이 필요한지 알려주신 뒤 다음 질문을 작성할 수 있어요.",
                buttons: [
                    {
                        type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                        label: "확인",
                        onClick: function() {
                            closeModal();
                            (0,RNPlugins/* historyBack */.$i)();
                        }
                    },
                    {
                        type: modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                        label: "답변 보기",
                        onClick: function() {
                            closeModal();
                            onClickAiAnswerDetail(unCheckedAiAnswer.questionPid);
                        }
                    }, 
                ]
            }
        });
    }, [
        unCheckedAiAnswer === null || unCheckedAiAnswer === void 0 ? void 0 : unCheckedAiAnswer.aiAnswerStatus
    ]);
    return {
        question: question,
        setQuestion: setQuestion,
        onClickCheckPregnant: onClickCheckPregnant,
        pregnant: pregnant,
        selectedCategoriesBottomSheetTabItem: selectedCategoriesBottomSheetTabItem,
        selectedTags: selectedTags,
        setSelectedTags: setSelectedTags,
        showCategoriesBottomSheet: showCategoriesBottomSheet,
        toggleCategoriesBottomSheet: toggleCategoriesBottomSheet,
        isUploadingImage: isUploadingImage,
        isSubmitLoading: isSubmitLoading,
        userProfile: userProfile,
        onClickCategoriesBottomSheetTabListItem: onClickCategoriesBottomSheetTabListItem,
        onCloseGuide: onCloseGuide,
        neverSeeAgainGuide: neverSeeAgainGuide,
        neverSeeAgain: neverSeeAgain,
        categoryGroup: categoryGroup,
        selectedTab: selectedTab,
        onClickCategoriesBottomSheetTab: onClickCategoriesBottomSheetTab,
        getSelectedTabItemList: getSelectedTabItemList,
        questionImages: questionImages,
        imageInputRef: imageInputRef,
        onDeleteImage: onDeleteImage,
        onUploadImage: onUploadImage,
        onHandleChange: onHandleChange,
        onClickApproveGeolocation: onClickApproveGeolocation,
        onClickNearDoctorAlertSkip: onClickNearDoctorAlertSkip,
        checkEnableSubmit: checkEnableSubmit,
        isSubmitButtonDisabled: isSubmitButtonDisabled,
        qnaWriteBottomSheetGroup: qnaWriteBottomSheetGroup,
        requestExpertAnswer: requestExpertAnswer,
        requestAiAnswer: requestAiAnswer,
        policyAgreementBottomSheetViewModel: policyAgreementBottomSheetViewModel
    };
};
/* harmony default export */ var qna_useQnaWriteMobileViewModel = (useQnaWriteMobileViewModel);

;// CONCATENATED MODULE: ./src/pages/content/qna/write/index.tsx
// PageDescription: 실시간 의료 상담 글 작성 페이지











var QnaWrite = function(param) {
    var client = param.client;
    var ref = (0,useAuthModal/* default */.Z)(false, true), setShowAuthModal = ref.setShowAuthModal, setTrackInfo = ref.setTrackInfo;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var qnaWriteMobileViewModel = qna_useQnaWriteMobileViewModel();
    (0,react.useEffect)(function() {
        // eslint-disable-next-line security/detect-possible-timing-attacks
        if (token === null && (0,RNPlugins/* isWebView */.vp)()) {
            return;
        }
        if (!token) {
            setShowAuthModal(true);
            setTrackInfo({
                campaign: "web_content_qna_write",
                content: "web_mid_mdl_main",
                buttonText: ""
            });
        }
    }, [
        setShowAuthModal,
        token,
        client
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "실시간 의료상담 - 닥터나우",
                description: "24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.",
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.WRITE.path */.Z6.QNA.WRITE.path),
                openGraph: {
                    title: "실시간 의료상담 - 닥터나우",
                    description: "24시간 대기하고 있는 닥터나우 의료인들이 실시간으로 답변해 드려요.",
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.QNA.WRITE.path */.Z6.QNA.WRITE.path),
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-qna.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Qna_QnaWriteMobileTemplate, {
                client: client,
                qnaWriteMobileViewModel: qnaWriteMobileViewModel
            })
        ]
    });
};
QnaWrite.Layout = DefaultLayout/* default */.Z;
/* harmony default export */ var write = (QnaWrite);


/***/ }),

/***/ 65083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ parseRealtimeQnaCardVo; },
/* harmony export */   "IF": function() { return /* binding */ parseAgreements; },
/* harmony export */   "P$": function() { return /* binding */ parseRelatedQnaVo; },
/* harmony export */   "ZA": function() { return /* binding */ parseQnaCategoryGroup; },
/* harmony export */   "fU": function() { return /* binding */ parseMagazineRelatedQnaVo; },
/* harmony export */   "l7": function() { return /* binding */ parseQnaAnswerReviewTagVo; }
/* harmony export */ });
/* unused harmony exports parseAgreementsByCategory, convertReviewTagExposure, parseQnaAnswerReviewsVo */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85244);
/* harmony import */ var _models_review_review__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84958);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72271);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4611);





var parseRelatedQnaVo = function(qnaDetail) {
    if (qnaDetail) {
        return qnaDetail.similarSearchQuestionCardCursorPageRequest.elements.map(function(element) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, element), {
                question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, element.question), {
                    attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
                }),
                answeredStatusText: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .getQnaAnswerStatus */ .uY)(element.answeredStatus),
                questionCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .absoluteDate */ .xt)(element.question.createdAt)
            });
        });
    }
    return [];
};
var parseRealtimeQnaCardVo = function(data) {
    if (data) {
        return data.flatMap(function(page) {
            return page.newestQuestionCardCursorPage.elements;
        }).map(function(element) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, element), {
                question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, element.question), {
                    attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
                }),
                questionCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .absoluteDate */ .xt)(element.question.createdAt),
                answerCreatedAt: element.answer ? (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .displayedAt */ .hX)(element.answer.createdAt) : null,
                answeredStatusText: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .getQnaAnswerStatus */ .uY)(element.answeredStatus)
            });
        });
    }
    return [];
};
var parseQnaCategoryGroup = function(data) {
    var categoryGroups = data.questionCategoryGroups;
    var parsedCategories = function() {
        return categoryGroups.map(function(questionCategory) {
            return {
                key: questionCategory.key,
                name: questionCategory.name,
                categories: questionCategory.questionCategories.map(function(category) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, category), {
                        key: questionCategory.key,
                        title: category.name,
                        content: category.description,
                        iconImageUrl: category.iconImageUrl,
                        value: category.questionCategoryId,
                        checked: false
                    });
                })
            };
        });
    };
    return {
        tabs: categoryGroups.map(function(category) {
            var key = category.key, name = category.name;
            return {
                key: key,
                label: name,
                value: key
            };
        }),
        tabsList: parsedCategories(),
        categories: parsedCategories().reduce(function(acc, cur) {
            return acc.concat(cur.categories);
        }, [])
    };
};
var parseMagazineRelatedQnaVo = function(qna) {
    if (qna) {
        return qna.magazineRelatedQuestionCards.map(function(element) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, element), {
                question: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, element.question), {
                    category: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, element.question.category), {
                        name: "관련 의료진 상담"
                    }),
                    attachments: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .sortImageBlindTypeFormat */ .zV)(element.question.attachments)
                }),
                answeredStatusText: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .getQnaAnswerStatus */ .uY)(element.answeredStatus),
                questionCreatedAt: (0,_utils_format__WEBPACK_IMPORTED_MODULE_2__/* .absoluteDate */ .xt)(element.question.createdAt)
            });
        });
    }
    return [];
};
var parseAgreementsByCategory = function(category) {
    if (category) {
        return category.getAgreementsByCategory[0];
    }
    return {};
};
var parseAgreements = function(agreements) {
    return agreements.getAgreementsByCategory;
};
var convertReviewTagExposure = function(exposureType) {
    switch(exposureType){
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .QnaAnswerReviewTagExposureType.Always */ .SUn.Always:
            return _models_review_review__WEBPACK_IMPORTED_MODULE_0__/* .ReviewTagExposure.ALWAYS */ .XV.ALWAYS;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .QnaAnswerReviewTagExposureType.Positive */ .SUn.Positive:
            return _models_review_review__WEBPACK_IMPORTED_MODULE_0__/* .ReviewTagExposure.POSITIVE */ .XV.POSITIVE;
        case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_1__/* .QnaAnswerReviewTagExposureType.Negative */ .SUn.Negative:
            return _models_review_review__WEBPACK_IMPORTED_MODULE_0__/* .ReviewTagExposure.NEGATIVE */ .XV.NEGATIVE;
        default:
            return _models_review_review__WEBPACK_IMPORTED_MODULE_0__/* .ReviewTagExposure.NONE */ .XV.NONE;
    }
};
var parseQnaAnswerReviewTagVo = function(data) {
    return data.qnaAnswerReviewTags.map(function(reviewTag) {
        return {
            exposureType: convertReviewTagExposure(reviewTag.exposureType),
            id: reviewTag.id,
            text: reviewTag.text
        };
    });
};
var parseQnaAnswerReviewsVo = function(data) {
    return data.qnaAnswerReviews.map(function(review) {
        return {
            id: review.id,
            answerPid: review.answerPid,
            reviewTags: review.reviewTags,
            rating: review.rating,
            content: review.content
        };
    });
};


/***/ }),

/***/ 92080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ neverSeeAgainState; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6983);


var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_1__/* .recoilPersist */ .J)().persistAtom;
var neverSeeAgainState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "neverSeeAgainState",
    default: {},
    effects_UNSTABLE: [
        persistAtom
    ]
});


/***/ }),

/***/ 3818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KL": function() { return /* binding */ userState; }
/* harmony export */ });
/* unused harmony exports getUserState, setUserState */
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var recoil_nexus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43584);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6983);



var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_2__/* .recoilPersist */ .J)().persistAtom;
var userState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "userState",
    default: {},
    effects_UNSTABLE: [
        persistAtom
    ]
});
var getUserState = function() {
    return getRecoil(userState);
};
var setUserState = function(userData) {
    setRecoil(userState, userData);
};


/***/ }),

/***/ 96469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ realTimeAnswerState; },
/* harmony export */   "x": function() { return /* binding */ recentKeywordListState; }
/* harmony export */ });
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4480);
/* harmony import */ var recoil_persist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6983);
/* harmony import */ var _utils_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80888);



var realTimeAnswerState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "realtimeAnswerState",
    default: false,
    effects: [
        (0,_utils_atom__WEBPACK_IMPORTED_MODULE_2__/* .localStorageEffect */ .N)("realtime")
    ]
});
var persistAtom = (0,recoil_persist__WEBPACK_IMPORTED_MODULE_1__/* .recoilPersist */ .J)().persistAtom;
var recentKeywordListState = (0,recoil__WEBPACK_IMPORTED_MODULE_0__.atom)({
    key: "recentKeywordListState",
    default: [],
    effects_UNSTABLE: [
        persistAtom
    ]
});


/***/ }),

/***/ 18457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q0": function() { return /* binding */ QnaCategoryType; },
/* harmony export */   "VI": function() { return /* binding */ QnaWriteBottomSheetType; },
/* harmony export */   "X9": function() { return /* binding */ NpsCompleteType; },
/* harmony export */   "bM": function() { return /* binding */ AnswererType; },
/* harmony export */   "kU": function() { return /* binding */ QnaAnswerWriteReviewStatus; }
/* harmony export */ });
/* unused harmony exports AnswerLikeType, ProfessionalFieldType */
var QnaCategoryType = {
    TREATMENT: "treatment",
    DEPARTMENT: "department"
};
var AnswerLikeType;
(function(AnswerLikeType) {
    AnswerLikeType["Dislike"] = "DISLIKE";
    AnswerLikeType["Like"] = "LIKE";
})(AnswerLikeType || (AnswerLikeType = {}));
var AnswererType;
(function(AnswererType) {
    AnswererType["Ai"] = "AI";
    AnswererType["Doctor"] = "DOCTOR";
    AnswererType["Nurse"] = "NURSE";
})(AnswererType || (AnswererType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["Department"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var NpsCompleteType;
(function(NpsCompleteType) {
    NpsCompleteType["Satisfied"] = "satisfied";
    NpsCompleteType["UnSatisfied"] = "unSatisfied";
})(NpsCompleteType || (NpsCompleteType = {}));
var QnaWriteBottomSheetType;
(function(QnaWriteBottomSheetType) {
    QnaWriteBottomSheetType["Default"] = "Default";
    QnaWriteBottomSheetType["Pregnant"] = "pregnant";
    QnaWriteBottomSheetType["Attachments"] = "attachments";
    QnaWriteBottomSheetType["Reject"] = "reject";
})(QnaWriteBottomSheetType || (QnaWriteBottomSheetType = {}));
var QnaAnswerWriteReviewStatus;
(function(QnaAnswerWriteReviewStatus) {
    QnaAnswerWriteReviewStatus["RatingReview"] = "RATING_REVIEW";
    QnaAnswerWriteReviewStatus["SatisfactionReview"] = "SATISFACTION_REVIEW";
    QnaAnswerWriteReviewStatus["CompleteReview"] = "COMPLETE_REVIEW";
})(QnaAnswerWriteReviewStatus || (QnaAnswerWriteReviewStatus = {}));


/***/ }),

/***/ 60288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ setImageUrl; },
/* harmony export */   "Kp": function() { return /* binding */ resizingImg; },
/* harmony export */   "NR": function() { return /* binding */ convertedHeicSingleImage; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "R2": function() { return /* binding */ redirectPostImage; },
/* harmony export */   "RW": function() { return /* binding */ convertHeic; },
/* harmony export */   "VM": function() { return /* binding */ onCompressImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22710);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62230);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);
/* eslint-disable @typescript-eslint/no-var-requires */ 



var convertHeic = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var heic2any, blob, newImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 4838).then(__webpack_require__.t.bind(__webpack_require__, 1616, 23))
                    ];
                case 1:
                    heic2any = _state.sent().default;
                    return [
                        4,
                        heic2any({
                            blob: file,
                            toType: "image/jpeg",
                            quality: 0.8
                        })
                    ];
                case 2:
                    blob = _state.sent();
                    newImage = new File([
                        blob
                    ], file.name.split(".")[0] + ".jpeg", {
                        type: "image/jpeg",
                        lastModified: new Date().getTime()
                    });
                    return [
                        2,
                        newImage
                    ];
            }
        });
    });
    return function convertHeic(file) {
        return _ref.apply(this, arguments);
    };
}();
var convertedHeicSingleImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(originFile) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!originFile.type.includes("heic")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertHeic(originFile)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    return [
                        2,
                        originFile
                    ];
            }
        });
    });
    return function convertedHeicSingleImage(originFile) {
        return _ref.apply(this, arguments);
    };
}();
var setImageUrl = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file) {
        var convertedImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!file.type.includes("heic")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        convertHeic(file)
                    ];
                case 1:
                    convertedImage = _state.sent();
                    return [
                        2,
                        Object.assign(convertedImage, {
                            blobUrl: URL.createObjectURL(convertedImage)
                        })
                    ];
                case 2:
                    return [
                        2,
                        Object.assign(file, {
                            blobUrl: URL.createObjectURL(file)
                        })
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function setImageUrl(file) {
        return _ref.apply(this, arguments);
    };
}();
var onCompressImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file, options) {
        var imageCompression, blob, compressedImage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 221).then(__webpack_require__.bind(__webpack_require__, 40221))
                    ];
                case 1:
                    imageCompression = _state.sent().default;
                    return [
                        4,
                        imageCompression(file, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options))
                    ];
                case 2:
                    blob = _state.sent();
                    compressedImage = new File([
                        blob
                    ], file.name.split(".")[0] + ".jpeg", {
                        type: "image/jpeg",
                        lastModified: new Date().getTime()
                    });
                    return [
                        2,
                        compressedImage
                    ];
            }
        });
    });
    return function onCompressImage(file, options) {
        return _ref.apply(this, arguments);
    };
}();
var resizingImg = function(param) {
    var originUrl = param.originUrl, width = param.width, height = param.height, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    return "".concat(originUrl, "?w=").concat(width, "&h=").concat(height, "&q=").concat(quality);
};
var isImage = function(image) {
    return image.type.includes("image");
};
var redirectPostImage = function(boardPostAttachmentId) {
    return "".concat(_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .BFF_BASE_URL */ .qG, "/api/v1/board/board-post-attachments/").concat(boardPostAttachmentId, "/redirect-to-signed-url");
};


/***/ }),

/***/ 92563:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7506,4329,6562,9535,1743,2549,4913,9774,2888,179], function() { return __webpack_exec__(88226); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);